/**
 * Generated from the server's OpenAPI document by tento-writer-js; do not edit.
 *
 * Optional and nullable fields. A response type (a route's 200 body reaches
 * it) or a request type carries a nullable key as a required
 * `field: Option<T>`, and its `make(fields)` takes every key: a nullable one
 * is stated, `null` when there is none. An optional key that cannot be
 * `null` is `field?: T`. Only a patch type omits a key to mean something.
 *
 * A patch type (a PATCH route's body, or an update the server applies
 * field by field, such as `EventUpdate`) is the one sanctioned
 * `field?: Option<T>`: an absent key leaves the field unchanged, a value sets
 * it, and `null` clears it — where the schema says the field is nullable.
 *
 * @module
 */
import { DateTime, NaiveDate, SemanticTime as _SemanticTime, Utc } from "@tento-chrono";
import { Rational as _Rational } from "@tento-core/rational";
import { Uuid } from "@tento-core/uuid";
import { AuthId as _AuthId, CalendarId as _CalendarId, CellId as _CellId, EventId as _EventId, RowUuid as _RowUuid, SheetUuid as _SheetUuid, SlotId as _SlotId, SyncKey as _SyncKey, TaskId as _TaskId, TemplateRowId as _TemplateRowId, UserId as _UserId } from "@tento-lona/sheets/ids/ids.ts";
import { RowId } from "@tento-lona/sheets/ids/row-id.ts";
import { RowNetworkKey } from "@tento-lona/sheets/ids/row-network-key.ts";
import { SheetId } from "@tento-lona/sheets/ids/sheet-id.ts";
import { SheetNetworkKey } from "@tento-lona/sheets/ids/sheet-network-key.ts";
import { SheetsNetwork } from "@tento-lona/sheets/wire/rows-network.ts";
import { WireDecode, type Option } from "@tento-lona/sheets/wire/wire-decode.ts";
import type { JsonValue as Json } from "@tento-core/json-reader";
import { Field, Model, Scalar } from "@tento-core/model";
/** A wire type's field table: the published name for the type of each companion's `MODEL`. */
export type ModelObject<T> = Model.Object<T>;
/** A validation result: the published name for what each companion's `safeHydrate` returns. */
export type ModelResult<T> = Model.Result<T>;
/** Any JSON value: what `hydrate` and `parse` take and `serialize` returns. */
export type { Json as JsonValue };

/**
 * The server's wire types, generated from its OpenAPI document: one type per
 * schema, each with a validating `hydrate` / `safeHydrate` pair and a
 * `make(fields)` builder that takes every key.
 */
export namespace Network {
  /** Generated from the `AccessRole` schema, declared once as `SheetsNetwork.AccessRole`. */
  export type AccessRole = SheetsNetwork.AccessRole;
  /** `@tento/lona/sheets`'s `CalendarId`: the one declaration, with its `parse` / `of`. */
  export type CalendarId = _CalendarId;
  /** The `parse` / `of` of `@tento/lona/sheets`'s `CalendarId`. */
  export const CalendarId: typeof _CalendarId = _CalendarId;
  /** `@tento/lona/sheets`'s `UserId`: the one declaration, with its `parse` / `of`. */
  export type UserId = _UserId;
  /** The `parse` / `of` of `@tento/lona/sheets`'s `UserId`. */
  export const UserId: typeof _UserId = _UserId;
  /** Generated from the `AddCalendarRequest` schema, declared once as `SheetsNetwork.AddCalendarRequest`. */
  export type AddCalendarRequest = SheetsNetwork.AddCalendarRequest;
  /** The wire codec for AddCalendarRequest, declared once as `SheetsNetwork.AddCalendarRequest`. */
  export const AddCalendarRequest: typeof SheetsNetwork.AddCalendarRequest = SheetsNetwork.AddCalendarRequest;
  /** Generated from the `AllRowItem` schema, declared once as `SheetsNetwork.AllRowItem`. */
  export type AllRowItem = SheetsNetwork.AllRowItem;
  /** The wire codec for AllRowItem, declared once as `SheetsNetwork.AllRowItem`. */
  export const AllRowItem: typeof SheetsNetwork.AllRowItem = SheetsNetwork.AllRowItem;
  /** `@tento/lona/sheets`'s `AuthId`: the one declaration, with its `parse` / `of`. */
  export type AuthId = _AuthId;
  /** The `parse` / `of` of `@tento/lona/sheets`'s `AuthId`. */
  export const AuthId: typeof _AuthId = _AuthId;
  /** Generated from the `AuthDisplay` schema. */
  export interface AuthDisplay {
    /** Generated from the `AuthDisplay` schema's `id` property. */
    id: AuthId;
    /** Generated from the `AuthDisplay` schema's `isPrimary` property. */
    isPrimary: boolean;
    /** Generated from the `AuthDisplay` schema's `requiresRelogin` property. */
    requiresRelogin: boolean;
    /** Generated from the `AuthDisplay` schema's `scopes` property. */
    scopes: string;
    /** Generated from the `AuthDisplay` schema's `source` property. */
    source: string;
  }
  /** Wire shape — matches `tento_lona_core::AuthInfo` field-for- field. Defined here so the route can derive `ToSchema` / `Serialize` without pulling utoipa into `tento-lona-core`. */
  export interface AuthInfoResponse {
    /** Generated from the `AuthInfoResponse` schema's `authId` property. */
    authId: AuthId;
    /** Generated from the `AuthInfoResponse` schema's `expiresAt` property. */
    expiresAt: Option<DateTime<Utc>>;
    /** Generated from the `AuthInfoResponse` schema's `issuedAt` property. */
    issuedAt: DateTime<Utc>;
    /** Generated from the `AuthInfoResponse` schema's `refreshExpiresAt` property. */
    refreshExpiresAt: Option<DateTime<Utc>>;
    /** Generated from the `AuthInfoResponse` schema's `requiresLogin` property. */
    requiresLogin: Option<boolean>;
    /** Generated from the `AuthInfoResponse` schema's `scopes` property. */
    scopes: string[];
    /** Generated from the `AuthInfoResponse` schema's `source` property. */
    source: string;
  }
  /** `@tento/lona/sheets`'s `CellId`: the one declaration, with its `parse` / `of`. */
  export type CellId = _CellId;
  /** The `parse` / `of` of `@tento/lona/sheets`'s `CellId`. */
  export const CellId: typeof _CellId = _CellId;
  /** Generated from the `SheetCellSchema` schema, declared once as `SheetsNetwork.SheetCellSchema`. */
  export type SheetCellSchema = SheetsNetwork.SheetCellSchema;
  /** The wire codec for SheetCellSchema, declared once as `SheetsNetwork.SheetCellSchema`. */
  export const SheetCellSchema: typeof SheetsNetwork.SheetCellSchema = SheetsNetwork.SheetCellSchema;
  /** Generated from the `SheetCell` schema, declared once as `SheetsNetwork.SheetCell`. */
  export type SheetCell = SheetsNetwork.SheetCell;
  /** Generated from the `DateRange` schema, declared once as `SheetsNetwork.DateRange`. */
  export type DateRange = SheetsNetwork.DateRange;
  /** The wire codec for DateRange, declared once as `SheetsNetwork.DateRange`. */
  export const DateRange: typeof SheetsNetwork.DateRange = SheetsNetwork.DateRange;
  /** Generated from the `BatchCellStatus` schema, declared once as `SheetsNetwork.BatchCellStatus`. */
  export type BatchCellStatus = SheetsNetwork.BatchCellStatus;
  /** `@tento/lona/sheets`'s `SyncKey`: the one declaration, with its `parse` / `of`. */
  export type SyncKey = _SyncKey;
  /** The `parse` / `of` of `@tento/lona/sheets`'s `SyncKey`. */
  export const SyncKey: typeof _SyncKey = _SyncKey;
  /** Generated from the `BatchCellResult` schema, declared once as `SheetsNetwork.BatchCellResult`. */
  export type BatchCellResult = SheetsNetwork.BatchCellResult;
  /** The wire codec for BatchCellResult, declared once as `SheetsNetwork.BatchCellResult`. */
  export const BatchCellResult: typeof SheetsNetwork.BatchCellResult = SheetsNetwork.BatchCellResult;
  /** Generated from the `BatchCellsRequest` schema, declared once as `SheetsNetwork.BatchCellsRequest`. */
  export type BatchCellsRequest = SheetsNetwork.BatchCellsRequest;
  /** The wire codec for BatchCellsRequest, declared once as `SheetsNetwork.BatchCellsRequest`. */
  export const BatchCellsRequest: typeof SheetsNetwork.BatchCellsRequest = SheetsNetwork.BatchCellsRequest;
  /** Generated from the `BatchCellsResponse` schema, declared once as `SheetsNetwork.BatchCellsResponse`. */
  export type BatchCellsResponse = SheetsNetwork.BatchCellsResponse;
  /** The wire codec for BatchCellsResponse, declared once as `SheetsNetwork.BatchCellsResponse`. */
  export const BatchCellsResponse: typeof SheetsNetwork.BatchCellsResponse = SheetsNetwork.BatchCellsResponse;
  /** Generated from the `BillingPortalSession` schema. */
  export interface BillingPortalSession {
    /** Generated from the `BillingPortalSession` schema's `isPaymentsTesting` property. */
    isPaymentsTesting: boolean;
    /** Generated from the `BillingPortalSession` schema's `url` property. */
    url: string;
  }
  /** Generated from the `Body` schema, declared once as `SheetsNetwork.Body`. */
  export type Body = SheetsNetwork.Body;
  /** The wire codec for Body, declared once as `SheetsNetwork.Body`. */
  export const Body: typeof SheetsNetwork.Body = SheetsNetwork.Body;
  /** Generated from the `CalendarAccessRole` schema, declared once as `SheetsNetwork.CalendarAccessRole`. */
  export type CalendarAccessRole = SheetsNetwork.CalendarAccessRole;
  /** Generated from the `CalendarCapabilitiesDisplay` schema, declared once as `SheetsNetwork.CalendarCapabilitiesDisplay`. */
  export type CalendarCapabilitiesDisplay = SheetsNetwork.CalendarCapabilitiesDisplay;
  /** The wire codec for CalendarCapabilitiesDisplay, declared once as `SheetsNetwork.CalendarCapabilitiesDisplay`. */
  export const CalendarCapabilitiesDisplay: typeof SheetsNetwork.CalendarCapabilitiesDisplay = SheetsNetwork.CalendarCapabilitiesDisplay;
  /** Generated from the `CalendarDisplay` schema, declared once as `SheetsNetwork.CalendarDisplay`. */
  export type CalendarDisplay = SheetsNetwork.CalendarDisplay;
  /** The wire codec for CalendarDisplay, declared once as `SheetsNetwork.CalendarDisplay`. */
  export const CalendarDisplay: typeof SheetsNetwork.CalendarDisplay = SheetsNetwork.CalendarDisplay;
  /** Generated from the `CalendarList` schema, declared once as `SheetsNetwork.CalendarList`. */
  export type CalendarList = SheetsNetwork.CalendarList;
  /** The wire codec for CalendarList, declared once as `SheetsNetwork.CalendarList`. */
  export const CalendarList: typeof SheetsNetwork.CalendarList = SheetsNetwork.CalendarList;
  /** Generated from the `CellWriteRequest` schema, declared once as `SheetsNetwork.CellWriteRequest`. */
  export type CellWriteRequest = SheetsNetwork.CellWriteRequest;
  /** The wire codec for CellWriteRequest, declared once as `SheetsNetwork.CellWriteRequest`. */
  export const CellWriteRequest: typeof SheetsNetwork.CellWriteRequest = SheetsNetwork.CellWriteRequest;
  /** Generated from the `CellWriteResponse` schema, declared once as `SheetsNetwork.CellWriteResponse`. */
  export type CellWriteResponse = SheetsNetwork.CellWriteResponse;
  /** The wire codec for CellWriteResponse, declared once as `SheetsNetwork.CellWriteResponse`. */
  export const CellWriteResponse: typeof SheetsNetwork.CellWriteResponse = SheetsNetwork.CellWriteResponse;
  /** Generated from the `CheckoutSession` schema. */
  export interface CheckoutSession {
    /** Generated from the `CheckoutSession` schema's `url` property. */
    url: string;
  }
  /** Generated from the `Color` schema. */
  export type Color = string | string[];
  /** Generated from the `ConferenceOperation` schema, declared once as `SheetsNetwork.ConferenceOperation`. */
  export type ConferenceOperation = SheetsNetwork.ConferenceOperation;
  /** Generated from the `ConferenceProvider` schema, declared once as `SheetsNetwork.ConferenceProvider`. */
  export type ConferenceProvider = SheetsNetwork.ConferenceProvider;
  /** Generated from the `ConnectionsBody` schema. */
  export type ConnectionsBody = {
    codeExchange: {
      code: string;
    };
  } | {
    credentials: {
      password: string;
      username: string;
    };
  } | {
    apiKey: {
      apiKey: string;
    };
  };
  /** Generated from the `CoreTheme` schema. */
  export interface CoreTheme {
    /** Generated from the `CoreTheme` schema's `blue` property. */
    blue: Option<Color>;
    /** Generated from the `CoreTheme` schema's `gray` property. */
    gray: Option<Color>;
    /** Generated from the `CoreTheme` schema's `green` property. */
    green: Option<Color>;
    /** Generated from the `CoreTheme` schema's `orange` property. */
    orange: Option<Color>;
    /** Generated from the `CoreTheme` schema's `purple` property. */
    purple: Option<Color>;
    /** Generated from the `CoreTheme` schema's `red` property. */
    red: Option<Color>;
    /** Generated from the `CoreTheme` schema's `teal` property. */
    teal: Option<Color>;
    /** Generated from the `CoreTheme` schema's `yellow` property. */
    yellow: Option<Color>;
  }
  /** Generated from the `CoreThemeVariants` schema. */
  export interface CoreThemeVariants {
    /** Generated from the `CoreThemeVariants` schema's `default` property. */
    default: Option<CoreTheme>;
    /** Generated from the `CoreThemeVariants` schema's `dimmed` property. */
    dimmed: Option<CoreTheme>;
  }
  /** Generated from the `CreateAcl` schema, declared once as `SheetsNetwork.CreateAcl`. */
  export type CreateAcl = SheetsNetwork.CreateAcl;
  /** The wire codec for CreateAcl, declared once as `SheetsNetwork.CreateAcl`. */
  export const CreateAcl: typeof SheetsNetwork.CreateAcl = SheetsNetwork.CreateAcl;
  /** Generated from the `TimeScaleCustom` schema, declared once as `SheetsNetwork.TimeScaleCustom`. */
  export type TimeScaleCustom = SheetsNetwork.TimeScaleCustom;
  /** Generated from the `SheetRowDb` schema, declared once as `SheetsNetwork.SheetRowDb`. */
  export type SheetRowDb = SheetsNetwork.SheetRowDb;
  /** The wire codec for SheetRowDb, declared once as `SheetsNetwork.SheetRowDb`. */
  export const SheetRowDb: typeof SheetsNetwork.SheetRowDb = SheetsNetwork.SheetRowDb;
  /** Generated from the `SheetRowEdge` schema, declared once as `SheetsNetwork.SheetRowEdge`. */
  export type SheetRowEdge = SheetsNetwork.SheetRowEdge;
  /** The wire codec for SheetRowEdge, declared once as `SheetsNetwork.SheetRowEdge`. */
  export const SheetRowEdge: typeof SheetsNetwork.SheetRowEdge = SheetsNetwork.SheetRowEdge;
  /** Generated from the `SheetRow` schema, declared once as `SheetsNetwork.SheetRow`. */
  export type SheetRow = SheetsNetwork.SheetRow;
  /** The wire codec for SheetRow, declared once as `SheetsNetwork.SheetRow`. */
  export const SheetRow: typeof SheetsNetwork.SheetRow = SheetsNetwork.SheetRow;
  /** Generated from the `CreateRowResponse` schema, declared once as `SheetsNetwork.CreateRowResponse`. */
  export type CreateRowResponse = SheetsNetwork.CreateRowResponse;
  /** The wire codec for CreateRowResponse, declared once as `SheetsNetwork.CreateRowResponse`. */
  export const CreateRowResponse: typeof SheetsNetwork.CreateRowResponse = SheetsNetwork.CreateRowResponse;
  /** `@tento/lona/sheets`'s `RowUuid`: the one declaration, with its `parse` / `of`. */
  export type RowUuid = _RowUuid;
  /** The `parse` / `of` of `@tento/lona/sheets`'s `RowUuid`. */
  export const RowUuid: typeof _RowUuid = _RowUuid;
  /** Generated from the `CreatedRow` schema, declared once as `SheetsNetwork.CreatedRow`. */
  export type CreatedRow = SheetsNetwork.CreatedRow;
  /** The wire codec for CreatedRow, declared once as `SheetsNetwork.CreatedRow`. */
  export const CreatedRow: typeof SheetsNetwork.CreatedRow = SheetsNetwork.CreatedRow;
  /** Generated from the `DateTimeRange` schema, declared once as `SheetsNetwork.DateTimeRange`. */
  export type DateTimeRange = SheetsNetwork.DateTimeRange;
  /** The wire codec for DateTimeRange, declared once as `SheetsNetwork.DateTimeRange`. */
  export const DateTimeRange: typeof SheetsNetwork.DateTimeRange = SheetsNetwork.DateTimeRange;
  /** Generated from the `DeleteAcl` schema, declared once as `SheetsNetwork.DeleteAcl`. */
  export type DeleteAcl = SheetsNetwork.DeleteAcl;
  /** The wire codec for DeleteAcl, declared once as `SheetsNetwork.DeleteAcl`. */
  export const DeleteAcl: typeof SheetsNetwork.DeleteAcl = SheetsNetwork.DeleteAcl;
  /** `@tento/lona/sheets`'s `EventId`: the one declaration, with its `parse` / `of`. */
  export type EventId = _EventId;
  /** The `parse` / `of` of `@tento/lona/sheets`'s `EventId`. */
  export const EventId: typeof _EventId = _EventId;
  /** Generated from the `EventVisibility` schema, declared once as `SheetsNetwork.EventVisibility`. */
  export type EventVisibility = SheetsNetwork.EventVisibility;
  /** Generated from the `EventCell` schema, declared once as `SheetsNetwork.EventCell`. */
  export type EventCell = SheetsNetwork.EventCell;
  /** The wire codec for EventCell, declared once as `SheetsNetwork.EventCell`. */
  export const EventCell: typeof SheetsNetwork.EventCell = SheetsNetwork.EventCell;
  /** Generated from the `EventDb` schema. */
  export interface EventDb {
    /** Generated from the `EventDb` schema's `attendees` property. */
    attendees: Option<Json>;
    /** Generated from the `EventDb` schema's `authId` property. */
    authId: AuthId;
    /** Generated from the `EventDb` schema's `calendarId` property. */
    calendarId: CalendarId;
    /** Generated from the `EventDb` schema's `category` property. */
    category: Option<string>;
    /** Generated from the `EventDb` schema's `conferenceData` property. */
    conferenceData: Option<Json>;
    /** Generated from the `EventDb` schema's `creatorDisplayName` property. */
    creatorDisplayName: Option<string>;
    /** Generated from the `EventDb` schema's `creatorEmail` property. */
    creatorEmail: Option<string>;
    /** Generated from the `EventDb` schema's `creatorId` property. */
    creatorId: Option<string>;
    /** Generated from the `EventDb` schema's `creatorIsSelf` property. */
    creatorIsSelf: Option<boolean>;
    /** Generated from the `EventDb` schema's `description` property. */
    description: Option<string>;
    /** Generated from the `EventDb` schema's `endDate` property. */
    endDate: Option<NaiveDate>;
    /** Generated from the `EventDb` schema's `endTimeZone` property. */
    endTimeZone: Option<string>;
    /** Generated from the `EventDb` schema's `et` property. */
    et: Option<DateTime<Utc>>;
    /** Generated from the `EventDb` schema's `etag` property. */
    etag: string;
    /** Generated from the `EventDb` schema's `eventType` property. */
    eventType: Option<string>;
    /** Generated from the `EventDb` schema's `icalId` property. */
    icalId: Option<string>;
    /** Generated from the `EventDb` schema's `id` property. */
    id: EventId;
    /** Generated from the `EventDb` schema's `location` property. */
    location: Option<string>;
    /** Generated from the `EventDb` schema's `queryRangeEnd` property. */
    queryRangeEnd: Option<DateTime<Utc>>;
    /** Generated from the `EventDb` schema's `queryRangeStart` property. */
    queryRangeStart: Option<DateTime<Utc>>;
    /** Generated from the `EventDb` schema's `recurrence` property. */
    recurrence: Option<string[]>;
    /** Generated from the `EventDb` schema's `recurringEventId` property. */
    recurringEventId: Option<EventId>;
    /** Generated from the `EventDb` schema's `source` property. */
    source: string;
    /** Generated from the `EventDb` schema's `st` property. */
    st: Option<DateTime<Utc>>;
    /** Generated from the `EventDb` schema's `startDate` property. */
    startDate: Option<NaiveDate>;
    /** Generated from the `EventDb` schema's `startTimeZone` property. */
    startTimeZone: Option<string>;
    /** Generated from the `EventDb` schema's `status` property. */
    status: Option<string>;
    /** Generated from the `EventDb` schema's `suggestedCategory` property. */
    suggestedCategory: Option<string>;
    /** Generated from the `EventDb` schema's `suggestedTimezone` property. */
    suggestedTimezone: Option<string>;
    /** Generated from the `EventDb` schema's `t` property. */
    t: Option<string>;
    /** Generated from the `EventDb` schema's `timezone` property. */
    timezone: Option<string>;
    /** Generated from the `EventDb` schema's `transparency` property. */
    transparency: Option<string>;
    /** Whether the user accepted `suggested_category` as the event's category (the classifier-WYSIWYG accept flag; mirrors `EventCell.use_suggested_category` in tento-lona-core). */
    useSuggestedCategory: Option<boolean>;
    /** Generated from the `EventDb` schema's `visibility` property. */
    visibility: Option<EventVisibility>;
  }
  /** Generated from the `EventUpdate` schema, declared once as `SheetsNetwork.EventUpdate`. */
  export type EventUpdate = SheetsNetwork.EventUpdate;
  /** The wire codec for EventUpdate, declared once as `SheetsNetwork.EventUpdate`. */
  export const EventUpdate: typeof SheetsNetwork.EventUpdate = SheetsNetwork.EventUpdate;
  /** Generated from the `GmailAttachment` schema. */
  export interface GmailAttachment {
    /** Gmail's base64url-encoded bytes, not a filesystem path. */
    data: string;
    /** Generated from the `GmailAttachment` schema's `size` property. */
    size: number;
  }
  /** Generated from the `GmailAttachmentId` schema. */
  export type GmailAttachmentId = string & { readonly __brand: "GmailAttachmentId" };
  /** The `GmailAttachmentId` id's `parse` / `of`. */
  export namespace GmailAttachmentId {
    /** The wire id `raw` as an `GmailAttachmentId`, or `null` when it is not one (an empty string). */
    export function parse(raw: string): Option<GmailAttachmentId> {
      return raw.length > 0 ? (raw as GmailAttachmentId) : null;
    }
    /** The id `raw` as an `GmailAttachmentId`; throws when `parse` refuses it. */
    export function of(raw: string): GmailAttachmentId {
      const id = parse(raw);
      if (id == null) throw new Error("GmailAttachmentId.of: not an GmailAttachmentId: " + JSON.stringify(raw));
      return id;
    }
  }
  /** Generated from the `GmailAttachmentInfo` schema. */
  export interface GmailAttachmentInfo {
    /** Generated from the `GmailAttachmentInfo` schema's `attachmentId` property. */
    attachmentId: Option<GmailAttachmentId>;
    /** Inline attachment bytes, base64url encoded. Larger parts use attachmentId. */
    data: Option<string>;
    /** Generated from the `GmailAttachmentInfo` schema's `filename` property. */
    filename: string;
    /** Generated from the `GmailAttachmentInfo` schema's `mimeType` property. */
    mimeType: string;
    /** Generated from the `GmailAttachmentInfo` schema's `partId` property. */
    partId: string;
    /** Generated from the `GmailAttachmentInfo` schema's `size` property. */
    size: number;
  }
  /** Generated from the `GmailMessageId` schema. */
  export type GmailMessageId = string & { readonly __brand: "GmailMessageId" };
  /** The `GmailMessageId` id's `parse` / `of`. */
  export namespace GmailMessageId {
    /** The wire id `raw` as an `GmailMessageId`, or `null` when it is not one (an empty string). */
    export function parse(raw: string): Option<GmailMessageId> {
      return raw.length > 0 ? (raw as GmailMessageId) : null;
    }
    /** The id `raw` as an `GmailMessageId`; throws when `parse` refuses it. */
    export function of(raw: string): GmailMessageId {
      const id = parse(raw);
      if (id == null) throw new Error("GmailMessageId.of: not an GmailMessageId: " + JSON.stringify(raw));
      return id;
    }
  }
  /** Generated from the `GmailThreadId` schema. */
  export type GmailThreadId = string & { readonly __brand: "GmailThreadId" };
  /** The `GmailThreadId` id's `parse` / `of`. */
  export namespace GmailThreadId {
    /** The wire id `raw` as an `GmailThreadId`, or `null` when it is not one (an empty string). */
    export function parse(raw: string): Option<GmailThreadId> {
      return raw.length > 0 ? (raw as GmailThreadId) : null;
    }
    /** The id `raw` as an `GmailThreadId`; throws when `parse` refuses it. */
    export function of(raw: string): GmailThreadId {
      const id = parse(raw);
      if (id == null) throw new Error("GmailThreadId.of: not an GmailThreadId: " + JSON.stringify(raw));
      return id;
    }
  }
  /** Generated from the `GmailMessageSummary` schema. */
  export interface GmailMessageSummary {
    /** Generated from the `GmailMessageSummary` schema's `date` property. */
    date: string;
    /** Generated from the `GmailMessageSummary` schema's `from` property. */
    from: string;
    /** Generated from the `GmailMessageSummary` schema's `id` property. */
    id: GmailMessageId;
    /** Generated from the `GmailMessageSummary` schema's `internalDate` property. */
    internalDate: Option<string>;
    /** Generated from the `GmailMessageSummary` schema's `labelIds` property. */
    labelIds: string[];
    /** Generated from the `GmailMessageSummary` schema's `snippet` property. */
    snippet: string;
    /** Generated from the `GmailMessageSummary` schema's `subject` property. */
    subject: string;
    /** Generated from the `GmailMessageSummary` schema's `threadId` property. */
    threadId: GmailThreadId;
    /** Generated from the `GmailMessageSummary` schema's `to` property. */
    to: string;
  }
  /** Generated from the `GmailMessage` schema. */
  export interface GmailMessage {
    /** Generated from the `GmailMessage` schema's `attachments` property. */
    attachments: GmailAttachmentInfo[];
    /** Untrusted HTML, returned as data; callers must not execute or render it unsanitized. */
    html: Option<string>;
    /** Generated from the `GmailMessage` schema's `summary` property. */
    summary: GmailMessageSummary;
    /** Generated from the `GmailMessage` schema's `text` property. */
    text: Option<string>;
    /** Generated from the `GmailMessage` schema's `warnings` property. */
    warnings: string[];
  }
  /** Generated from the `GmailSearchPage` schema. */
  export interface GmailSearchPage {
    /** Generated from the `GmailSearchPage` schema's `messages` property. */
    messages: GmailMessageSummary[];
    /** Generated from the `GmailSearchPage` schema's `nextPageToken` property. */
    nextPageToken: Option<string>;
    /** Generated from the `GmailSearchPage` schema's `resultSizeEstimate` property. */
    resultSizeEstimate: Option<number>;
  }
  /** Generated from the `GmailThread` schema. */
  export interface GmailThread {
    /** Generated from the `GmailThread` schema's `id` property. */
    id: GmailThreadId;
    /** Generated from the `GmailThread` schema's `messages` property. */
    messages: GmailMessage[];
  }
  /** Generated from the `RowDef` schema, declared once as `SheetsNetwork.RowDef`. */
  export type RowDef = SheetsNetwork.RowDef;
  /** The wire codec for RowDef, declared once as `SheetsNetwork.RowDef`. */
  export const RowDef: typeof SheetsNetwork.RowDef = SheetsNetwork.RowDef;
  /** Generated from the `NewRowWithAttributes` schema, declared once as `SheetsNetwork.NewRowWithAttributes`. */
  export type NewRowWithAttributes = SheetsNetwork.NewRowWithAttributes;
  /** The wire codec for NewRowWithAttributes, declared once as `SheetsNetwork.NewRowWithAttributes`. */
  export const NewRowWithAttributes: typeof SheetsNetwork.NewRowWithAttributes = SheetsNetwork.NewRowWithAttributes;
  /** Generated from the `HydrateChildrenBody` schema, declared once as `SheetsNetwork.HydrateChildrenBody`. */
  export type HydrateChildrenBody = SheetsNetwork.HydrateChildrenBody;
  /** The wire codec for HydrateChildrenBody, declared once as `SheetsNetwork.HydrateChildrenBody`. */
  export const HydrateChildrenBody: typeof SheetsNetwork.HydrateChildrenBody = SheetsNetwork.HydrateChildrenBody;
  /** Generated from the `HydratedRow` schema, declared once as `SheetsNetwork.HydratedRow`. */
  export type HydratedRow = SheetsNetwork.HydratedRow;
  /** The wire codec for HydratedRow, declared once as `SheetsNetwork.HydratedRow`. */
  export const HydratedRow: typeof SheetsNetwork.HydratedRow = SheetsNetwork.HydratedRow;
  /** Generated from the `HydrateChildrenResponse` schema, declared once as `SheetsNetwork.HydrateChildrenResponse`. */
  export type HydrateChildrenResponse = SheetsNetwork.HydrateChildrenResponse;
  /** The wire codec for HydrateChildrenResponse, declared once as `SheetsNetwork.HydrateChildrenResponse`. */
  export const HydrateChildrenResponse: typeof SheetsNetwork.HydrateChildrenResponse = SheetsNetwork.HydrateChildrenResponse;
  /** `@tento/lona/sheets`'s `SheetUuid`: the one declaration, with its `parse` / `of`. */
  export type SheetUuid = _SheetUuid;
  /** The `parse` / `of` of `@tento/lona/sheets`'s `SheetUuid`. */
  export const SheetUuid: typeof _SheetUuid = _SheetUuid;
  /** Generated from the `TimeScale` schema, declared once as `SheetsNetwork.TimeScale`. */
  export type TimeScale = SheetsNetwork.TimeScale;
  /** Generated from the `Sheet` schema, declared once as `SheetsNetwork.Sheet`. */
  export type Sheet = SheetsNetwork.Sheet;
  /** The wire codec for Sheet, declared once as `SheetsNetwork.Sheet`. */
  export const Sheet: typeof SheetsNetwork.Sheet = SheetsNetwork.Sheet;
  /** Generated from the `UserSheet` schema, declared once as `SheetsNetwork.UserSheet`. */
  export type UserSheet = SheetsNetwork.UserSheet;
  /** The wire codec for UserSheet, declared once as `SheetsNetwork.UserSheet`. */
  export const UserSheet: typeof SheetsNetwork.UserSheet = SheetsNetwork.UserSheet;
  /** Generated from the `UserSheetWithRows` schema, declared once as `SheetsNetwork.UserSheetWithRows`. */
  export type UserSheetWithRows = SheetsNetwork.UserSheetWithRows;
  /** The wire codec for UserSheetWithRows, declared once as `SheetsNetwork.UserSheetWithRows`. */
  export const UserSheetWithRows: typeof SheetsNetwork.UserSheetWithRows = SheetsNetwork.UserSheetWithRows;
  /** `@tento/lona/sheets`'s `TaskId`: the one declaration, with its `parse` / `of`. */
  export type TaskId = _TaskId;
  /** The `parse` / `of` of `@tento/lona/sheets`'s `TaskId`. */
  export const TaskId: typeof _TaskId = _TaskId;
  /** Generated from the `TaskPriority` schema, declared once as `SheetsNetwork.TaskPriority`. */
  export type TaskPriority = SheetsNetwork.TaskPriority;
  /** Generated from the `TaskStatus` schema, declared once as `SheetsNetwork.TaskStatus`. */
  export type TaskStatus = SheetsNetwork.TaskStatus;
  /** Generated from the `TaskAttributes` schema, declared once as `SheetsNetwork.TaskAttributes`. */
  export type TaskAttributes = SheetsNetwork.TaskAttributes;
  /** The wire codec for TaskAttributes, declared once as `SheetsNetwork.TaskAttributes`. */
  export const TaskAttributes: typeof SheetsNetwork.TaskAttributes = SheetsNetwork.TaskAttributes;
  /** Generated from the `Task` schema, declared once as `SheetsNetwork.Task`. */
  export type Task = SheetsNetwork.Task;
  /** The wire codec for Task, declared once as `SheetsNetwork.Task`. */
  export const Task: typeof SheetsNetwork.Task = SheetsNetwork.Task;
  /** Product tier for Lona subscriptions. No longer stored in database - derived from product_keys.status (LonaStatus). */
  export type LonaProduct = "Personal" | "Pro" | "Teams";
  /** Generated from the `SemanticThemeVariant` schema. */
  export interface SemanticThemeVariant {
    /** Generated from the `SemanticThemeVariant` schema's `events` property. */
    events: Option<{
    }>;
    /** Generated from the `SemanticThemeVariant` schema's `sheet` property. */
    sheet: Option<{
    }>;
  }
  /** Generated from the `SemanticTheme` schema. */
  export interface SemanticTheme {
    /** Generated from the `SemanticTheme` schema's `default` property. */
    default: Option<SemanticThemeVariant>;
    /** Generated from the `SemanticTheme` schema's `dimmed` property. */
    dimmed: Option<SemanticThemeVariant>;
  }
  /** Generated from the `Theme` schema. */
  export interface Theme {
    /** Generated from the `Theme` schema's `base` property. */
    base: Option<CoreThemeVariants>;
    /** Generated from the `Theme` schema's `semantic` property. */
    semantic: Option<SemanticTheme>;
  }
  /** Generated from the `NamedTheme` schema. */
  export interface NamedTheme {
    /** Generated from the `NamedTheme` schema's `name` property. */
    name: Option<string>;
    /** Generated from the `NamedTheme` schema's `theme` property. */
    theme: Option<Theme>;
  }
  /** Generated from the `UserInfo` schema. */
  export interface UserInfo {
    /** Generated from the `UserInfo` schema's `activeProduct` property. */
    activeProduct: Option<LonaProduct>;
    /** Generated from the `UserInfo` schema's `displayName` property. */
    displayName: string;
    /** Generated from the `UserInfo` schema's `graceExpiresAt` property. */
    graceExpiresAt: Option<DateTime<Utc>>;
    /** Generated from the `UserInfo` schema's `id` property. */
    id: UserId;
    /** Generated from the `UserInfo` schema's `isServiceAccount` property. */
    isServiceAccount: boolean;
    /** Generated from the `UserInfo` schema's `theme` property. */
    theme: NamedTheme;
  }
  /** Initial app state for the authenticated user, including capability advertisements. */
  export interface InitialPayload {
    /** Connected authentication accounts shown to this user. */
    auths: AuthDisplay[];
    /** Calendar display settings for the user's connected calendars. */
    calendars: CalendarList[];
    /** What this server build honours, for clients that switch behaviour on it. `clientRowIds`: row creates accept a client-minted id — same-owner replay (atomic per id), 409 `row_id_conflict` / `row_id_deleted` (row-identity stage 1). Unknown entries are ignored by clients. */
    capabilities: Option<string[]>;
    /** The selected persisted sheet, or the first viewable sheet as fallback; null when none exists. */
    sheet: Option<UserSheetWithRows>;
    /** Sheets this user may view, as returned at boot. */
    sheetList: UserSheet[];
    /** The user's tasks returned with the initial app state. */
    tasks: Task[];
    /** The authenticated user's identity, theme and product access. */
    user: UserInfo;
  }
  /** Generated from the `LinkRowRequest` schema, declared once as `SheetsNetwork.LinkRowRequest`. */
  export type LinkRowRequest = SheetsNetwork.LinkRowRequest;
  /** The wire codec for LinkRowRequest, declared once as `SheetsNetwork.LinkRowRequest`. */
  export const LinkRowRequest: typeof SheetsNetwork.LinkRowRequest = SheetsNetwork.LinkRowRequest;
  /** Generated from the `LinkableRow` schema, declared once as `SheetsNetwork.LinkableRow`. */
  export type LinkableRow = SheetsNetwork.LinkableRow;
  /** The wire codec for LinkableRow, declared once as `SheetsNetwork.LinkableRow`. */
  export const LinkableRow: typeof SheetsNetwork.LinkableRow = SheetsNetwork.LinkableRow;
  /** Generated from the `LogsCell` schema, declared once as `SheetsNetwork.LogsCell`. */
  export type LogsCell = SheetsNetwork.LogsCell;
  /** The wire codec for LogsCell, declared once as `SheetsNetwork.LogsCell`. */
  export const LogsCell: typeof SheetsNetwork.LogsCell = SheetsNetwork.LogsCell;
  /** LonaStatus represents a user's access tier. It's the union of LonaProduct (Personal, Pro, Teams) plus Trial and Invited. */
  export type LonaStatus = "Personal" | "Pro" | "Teams" | "Trial" | "Invited";
  /** Generated from the `LookupKeyExistsResponse` schema, declared once as `SheetsNetwork.LookupKeyExistsResponse`. */
  export type LookupKeyExistsResponse = SheetsNetwork.LookupKeyExistsResponse;
  /** The wire codec for LookupKeyExistsResponse, declared once as `SheetsNetwork.LookupKeyExistsResponse`. */
  export const LookupKeyExistsResponse: typeof SheetsNetwork.LookupKeyExistsResponse = SheetsNetwork.LookupKeyExistsResponse;
  /** Generated from the `MailAccount` schema. */
  export interface MailAccount {
    /** Generated from the `MailAccount` schema's `authId` property. */
    authId: AuthId;
    /** Generated from the `MailAccount` schema's `readable` property. */
    readable: boolean;
  }
  /** Generated from the `MailConnectBody` schema. */
  export interface MailConnectBody {
    /** Generated from the `MailConnectBody` schema's `authId` property. */
    authId: AuthId;
    /** Generated from the `MailConnectBody` schema's `code` property. */
    code: string;
  }
  /** Generated from the `ManageRequest` schema. */
  export interface ManageRequest {
    /** Generated from the `ManageRequest` schema's `returnUrl` property. */
    returnUrl: Option<string>;
  }
  /** Generated from the `NewEvent` schema, declared once as `SheetsNetwork.NewEvent`. */
  export type NewEvent = SheetsNetwork.NewEvent;
  /** The wire codec for NewEvent, declared once as `SheetsNetwork.NewEvent`. */
  export const NewEvent: typeof SheetsNetwork.NewEvent = SheetsNetwork.NewEvent;
  /** Generated from the `SurfaceKind` schema, declared once as `SheetsNetwork.SurfaceKind`. */
  export type SurfaceKind = SheetsNetwork.SurfaceKind;
  /** Generated from the `NewRow` schema, declared once as `SheetsNetwork.NewRow`. */
  export type NewRow = SheetsNetwork.NewRow;
  /** The wire codec for NewRow, declared once as `SheetsNetwork.NewRow`. */
  export const NewRow: typeof SheetsNetwork.NewRow = SheetsNetwork.NewRow;
  /** Generated from the `NewRowBody` schema, declared once as `SheetsNetwork.NewRowBody`. */
  export type NewRowBody = SheetsNetwork.NewRowBody;
  /** The wire codec for NewRowBody, declared once as `SheetsNetwork.NewRowBody`. */
  export const NewRowBody: typeof SheetsNetwork.NewRowBody = SheetsNetwork.NewRowBody;
  /** Generated from the `NewSheet` schema, declared once as `SheetsNetwork.NewSheet`. */
  export type NewSheet = SheetsNetwork.NewSheet;
  /** The wire codec for NewSheet, declared once as `SheetsNetwork.NewSheet`. */
  export const NewSheet: typeof SheetsNetwork.NewSheet = SheetsNetwork.NewSheet;
  /** Generated from the `NewUserSheet` schema, declared once as `SheetsNetwork.NewUserSheet`. */
  export type NewUserSheet = SheetsNetwork.NewUserSheet;
  /** The wire codec for NewUserSheet, declared once as `SheetsNetwork.NewUserSheet`. */
  export const NewUserSheet: typeof SheetsNetwork.NewUserSheet = SheetsNetwork.NewUserSheet;
  /** Generated from the `ProductKeyItem` schema. */
  export interface ProductKeyItem {
    /** Generated from the `ProductKeyItem` schema's `code` property. */
    code: string;
    /** Generated from the `ProductKeyItem` schema's `createdAt` property. */
    createdAt: DateTime<Utc>;
    /** Generated from the `ProductKeyItem` schema's `eligibility` property. */
    eligibility: string;
    /** Generated from the `ProductKeyItem` schema's `expiresAfterSecs` property. */
    expiresAfterSecs: Option<number>;
    /** Generated from the `ProductKeyItem` schema's `expiresAt` property. */
    expiresAt: Option<DateTime<Utc>>;
    /** Generated from the `ProductKeyItem` schema's `isActive` property. */
    isActive: boolean;
    /** Generated from the `ProductKeyItem` schema's `origin` property. */
    origin: string;
    /** Generated from the `ProductKeyItem` schema's `redeemedAt` property. */
    redeemedAt: Option<DateTime<Utc>>;
    /** Generated from the `ProductKeyItem` schema's `scope` property. */
    scope: string;
    /** Generated from the `ProductKeyItem` schema's `source` property. */
    source: string;
    /** Generated from the `ProductKeyItem` schema's `status` property. */
    status: LonaStatus;
  }
  /** Generated from the `PaginatedProductKeysResponse` schema. */
  export interface PaginatedProductKeysResponse {
    /** Generated from the `PaginatedProductKeysResponse` schema's `items` property. */
    items: ProductKeyItem[];
    /** Generated from the `PaginatedProductKeysResponse` schema's `page` property. */
    page: number;
    /** Generated from the `PaginatedProductKeysResponse` schema's `pageSize` property. */
    pageSize: number;
    /** Generated from the `PaginatedProductKeysResponse` schema's `total` property. */
    total: number;
  }
  /** Generated from the `RowSortField` schema, declared once as `SheetsNetwork.RowSortField`. */
  export type RowSortField = SheetsNetwork.RowSortField;
  /** Generated from the `SortDirection` schema, declared once as `SheetsNetwork.SortDirection`. */
  export type SortDirection = SheetsNetwork.SortDirection;
  /** Generated from the `PaginatedRowsResponse` schema, declared once as `SheetsNetwork.PaginatedRowsResponse`. */
  export type PaginatedRowsResponse = SheetsNetwork.PaginatedRowsResponse;
  /** The wire codec for PaginatedRowsResponse, declared once as `SheetsNetwork.PaginatedRowsResponse`. */
  export const PaginatedRowsResponse: typeof SheetsNetwork.PaginatedRowsResponse = SheetsNetwork.PaginatedRowsResponse;
  /** Generated from the `PatchRowResponse` schema, declared once as `SheetsNetwork.PatchRowResponse`. */
  export type PatchRowResponse = SheetsNetwork.PatchRowResponse;
  /** The wire codec for PatchRowResponse, declared once as `SheetsNetwork.PatchRowResponse`. */
  export const PatchRowResponse: typeof SheetsNetwork.PatchRowResponse = SheetsNetwork.PatchRowResponse;
  /** Generated from the `PatchRow_PendingValidation` schema, declared once as `SheetsNetwork.PatchRow_PendingValidation`. */
  export type PatchRow_PendingValidation = SheetsNetwork.PatchRow_PendingValidation;
  /** The wire codec for PatchRow_PendingValidation, declared once as `SheetsNetwork.PatchRow_PendingValidation`. */
  export const PatchRow_PendingValidation: typeof SheetsNetwork.PatchRow_PendingValidation = SheetsNetwork.PatchRow_PendingValidation;
  /** Generated from the `PaymentsModeParam` schema. */
  export type PaymentsModeParam = "live" | "test";
  /** Generated from the `PendingValidation` schema, declared once as `SheetsNetwork.PendingValidation`. */
  export type PendingValidation = SheetsNetwork.PendingValidation;
  /** Generated from the `PlanActionType` schema. */
  export type PlanActionType = "manage" | "upgrade" | "downgrade" | "contact";
  /** Generated from the `PlanId` schema. */
  export type PlanId = string & { readonly __brand: "PlanId" };
  /** The `PlanId` id's `parse` / `of`. */
  export namespace PlanId {
    /** The wire id `raw` as an `PlanId`, or `null` when it is not one (an empty string). */
    export function parse(raw: string): Option<PlanId> {
      return raw.length > 0 ? (raw as PlanId) : null;
    }
    /** The id `raw` as an `PlanId`; throws when `parse` refuses it. */
    export function of(raw: string): PlanId {
      const id = parse(raw);
      if (id == null) throw new Error("PlanId.of: not an PlanId: " + JSON.stringify(raw));
      return id;
    }
  }
  /** Generated from the `PlanOption` schema. */
  export interface PlanOption {
    /** Generated from the `PlanOption` schema's `action` property. */
    action: PlanActionType;
    /** Generated from the `PlanOption` schema's `id` property. */
    id: PlanId;
    /** Generated from the `PlanOption` schema's `priceUsdPerMonth` property. */
    priceUsdPerMonth: Option<number>;
    /** Generated from the `PlanOption` schema's `priceUsdPerMonthAnnual` property. */
    priceUsdPerMonthAnnual: Option<number>;
    /** Generated from the `PlanOption` schema's `tier` property. */
    tier: number;
  }
  /** Generated from the `PlanCatalog` schema. */
  export interface PlanCatalog {
    /** Generated from the `PlanCatalog` schema's `activeProduct` property. */
    activeProduct: Option<LonaProduct>;
    /** Generated from the `PlanCatalog` schema's `activeProductCode` property. */
    activeProductCode: Option<string>;
    /** Generated from the `PlanCatalog` schema's `activeProductExpiresAfterSecs` property. */
    activeProductExpiresAfterSecs: Option<number>;
    /** Generated from the `PlanCatalog` schema's `activeProductSource` property. */
    activeProductSource: Option<string>;
    /** Generated from the `PlanCatalog` schema's `isPaymentsTesting` property. */
    isPaymentsTesting: boolean;
    /** Generated from the `PlanCatalog` schema's `plans` property. */
    plans: PlanOption[];
  }
  /** Generated from the `ProductKeyRequest` schema. */
  export interface ProductKeyRequest {
    /** Generated from the `ProductKeyRequest` schema's `code` property. */
    code: string;
  }
  /** Generated from the `ProductKeyResponse` schema. */
  export interface ProductKeyResponse {
    /** Generated from the `ProductKeyResponse` schema's `code` property. */
    code: Option<string>;
    /** Generated from the `ProductKeyResponse` schema's `expiresAfterSecs` property. */
    expiresAfterSecs: Option<number>;
    /** Generated from the `ProductKeyResponse` schema's `fromCookie` property. */
    fromCookie: boolean;
    /** Generated from the `ProductKeyResponse` schema's `keys` property. */
    keys: ProductKeyItem[];
    /** Generated from the `ProductKeyResponse` schema's `status` property. */
    status: string;
    /** Generated from the `ProductKeyResponse` schema's `tier` property. */
    tier: Option<string>;
  }
  /** Generated from the `PublicSchedulingLinkInfo` schema. */
  export interface PublicSchedulingLinkInfo {
    /** Generated from the `PublicSchedulingLinkInfo` schema's `description` property. */
    description: Option<string>;
    /** Generated from the `PublicSchedulingLinkInfo` schema's `durationMinutes` property. */
    durationMinutes: number;
    /** Generated from the `PublicSchedulingLinkInfo` schema's `slug` property. */
    slug: string;
    /** Generated from the `PublicSchedulingLinkInfo` schema's `timezone` property. */
    timezone: string;
    /** Generated from the `PublicSchedulingLinkInfo` schema's `title` property. */
    title: string;
  }
  /** Generated from the `ResolvedRowInfo` schema, declared once as `SheetsNetwork.ResolvedRowInfo`. */
  export type ResolvedRowInfo = SheetsNetwork.ResolvedRowInfo;
  /** The wire codec for ResolvedRowInfo, declared once as `SheetsNetwork.ResolvedRowInfo`. */
  export const ResolvedRowInfo: typeof SheetsNetwork.ResolvedRowInfo = SheetsNetwork.ResolvedRowInfo;
  /** Generated from the `ResolvedRowsResponse` schema, declared once as `SheetsNetwork.ResolvedRowsResponse`. */
  export type ResolvedRowsResponse = SheetsNetwork.ResolvedRowsResponse;
  /** The wire codec for ResolvedRowsResponse, declared once as `SheetsNetwork.ResolvedRowsResponse`. */
  export const ResolvedRowsResponse: typeof SheetsNetwork.ResolvedRowsResponse = SheetsNetwork.ResolvedRowsResponse;
  /** Generated from the `ResolvedSheetState` schema, declared once as `SheetsNetwork.ResolvedSheetState`. */
  export type ResolvedSheetState = SheetsNetwork.ResolvedSheetState;
  /** Generated from the `ResolvedSheetKey` schema, declared once as `SheetsNetwork.ResolvedSheetKey`. */
  export type ResolvedSheetKey = SheetsNetwork.ResolvedSheetKey;
  /** The wire codec for ResolvedSheetKey, declared once as `SheetsNetwork.ResolvedSheetKey`. */
  export const ResolvedSheetKey: typeof SheetsNetwork.ResolvedSheetKey = SheetsNetwork.ResolvedSheetKey;
  /** Generated from the `RestoreRequest` schema, declared once as `SheetsNetwork.RestoreRequest`. */
  export type RestoreRequest = SheetsNetwork.RestoreRequest;
  /** The wire codec for RestoreRequest, declared once as `SheetsNetwork.RestoreRequest`. */
  export const RestoreRequest: typeof SheetsNetwork.RestoreRequest = SheetsNetwork.RestoreRequest;
  /** Generated from the `RowReorderBodySchema` schema, declared once as `SheetsNetwork.RowReorderBodySchema`. */
  export type RowReorderBodySchema = SheetsNetwork.RowReorderBodySchema;
  /** The wire codec for RowReorderBodySchema, declared once as `SheetsNetwork.RowReorderBodySchema`. */
  export const RowReorderBodySchema: typeof SheetsNetwork.RowReorderBodySchema = SheetsNetwork.RowReorderBodySchema;
  /** Generated from the `RowReorderResponse` schema, declared once as `SheetsNetwork.RowReorderResponse`. */
  export type RowReorderResponse = SheetsNetwork.RowReorderResponse;
  /** The wire codec for RowReorderResponse, declared once as `SheetsNetwork.RowReorderResponse`. */
  export const RowReorderResponse: typeof SheetsNetwork.RowReorderResponse = SheetsNetwork.RowReorderResponse;
  /** Generated from the `SandboxRequest` schema. */
  export interface SandboxRequest {
    /** Generated from the `SandboxRequest` schema's `isPaymentsTesting` property. */
    isPaymentsTesting: boolean;
  }
  /** Generated from the `SandboxResponse` schema. */
  export interface SandboxResponse {
    /** Generated from the `SandboxResponse` schema's `isPaymentsTesting` property. */
    isPaymentsTesting: boolean;
  }
  /** A wrapper around a string that may contain characters unsafe for filesystem operations. This type is intended to safely handle potentially unsafe user input that will be used in filesystem operations, such as filenames or path components. It provides methods to sanitize the string for various use cases to prevent path traversal attacks and other security issues. */
  export type ScaryUserString = string;
  /** Generated from the `SheetReorderBodySchema` schema, declared once as `SheetsNetwork.SheetReorderBodySchema`. */
  export type SheetReorderBodySchema = SheetsNetwork.SheetReorderBodySchema;
  /** The wire codec for SheetReorderBodySchema, declared once as `SheetsNetwork.SheetReorderBodySchema`. */
  export const SheetReorderBodySchema: typeof SheetsNetwork.SheetReorderBodySchema = SheetsNetwork.SheetReorderBodySchema;
  /** Generated from the `SheetReorderResponse` schema, declared once as `SheetsNetwork.SheetReorderResponse`. */
  export type SheetReorderResponse = SheetsNetwork.SheetReorderResponse;
  /** The wire codec for SheetReorderResponse, declared once as `SheetsNetwork.SheetReorderResponse`. */
  export const SheetReorderResponse: typeof SheetsNetwork.SheetReorderResponse = SheetsNetwork.SheetReorderResponse;
  /** Generated from the `SheetRowDataResponse` schema, declared once as `SheetsNetwork.SheetRowDataResponse`. */
  export type SheetRowDataResponse = SheetsNetwork.SheetRowDataResponse;
  /** The wire codec for SheetRowDataResponse, declared once as `SheetsNetwork.SheetRowDataResponse`. */
  export const SheetRowDataResponse: typeof SheetsNetwork.SheetRowDataResponse = SheetsNetwork.SheetRowDataResponse;
  /** Generated from the `SheetUpdateAttributes` schema, declared once as `SheetsNetwork.SheetUpdateAttributes`. */
  export type SheetUpdateAttributes = SheetsNetwork.SheetUpdateAttributes;
  /** The wire codec for SheetUpdateAttributes, declared once as `SheetsNetwork.SheetUpdateAttributes`. */
  export const SheetUpdateAttributes: typeof SheetsNetwork.SheetUpdateAttributes = SheetsNetwork.SheetUpdateAttributes;
  /** Generated from the `SigninResult` schema. */
  export interface SigninResult {
    /** Generated from the `SigninResult` schema's `promoStatus` property. */
    promoStatus: Option<LonaStatus>;
    /** Generated from the `SigninResult` schema's `scopes` property. */
    scopes: string;
  }
  /** `@tento/lona/sheets`'s `SlotId`: the one declaration, with its `parse` / `of`. */
  export type SlotId = _SlotId;
  /** The `parse` / `of` of `@tento/lona/sheets`'s `SlotId`. */
  export const SlotId: typeof _SlotId = _SlotId;
  /** Generated from the `SlotCell` schema, declared once as `SheetsNetwork.SlotCell`. */
  export type SlotCell = SheetsNetwork.SlotCell;
  /** The wire codec for SlotCell, declared once as `SheetsNetwork.SlotCell`. */
  export const SlotCell: typeof SheetsNetwork.SlotCell = SheetsNetwork.SlotCell;
  /** The same-origin destination after attempting to start a trial. */
  export interface StartTrialResponse {
    /** Same-origin path the app navigates to next: `/` (trial started, or the user is already entitled), `/subscription/expired` (the trial was used up), or `/waitlist` (the user cap is reached). */
    redirect: string;
  }
  /** Generated from the `SubscriptionSyncResponse` schema. */
  export interface SubscriptionSyncResponse {
    /** Generated from the `SubscriptionSyncResponse` schema's `graceExpiresAt` property. */
    graceExpiresAt: Option<DateTime<Utc>>;
    /** Generated from the `SubscriptionSyncResponse` schema's `hasActiveKey` property. */
    hasActiveKey: boolean;
  }
  /** Generated from the `SyncRange` schema, declared once as `SheetsNetwork.SyncRange`. */
  export type SyncRange = SheetsNetwork.SyncRange;
  /** The wire codec for SyncRange, declared once as `SheetsNetwork.SyncRange`. */
  export const SyncRange: typeof SheetsNetwork.SyncRange = SheetsNetwork.SyncRange;
  /** Generated from the `SyncRowRequest` schema, declared once as `SheetsNetwork.SyncRowRequest`. */
  export type SyncRowRequest = SheetsNetwork.SyncRowRequest;
  /** The wire codec for SyncRowRequest, declared once as `SheetsNetwork.SyncRowRequest`. */
  export const SyncRowRequest: typeof SheetsNetwork.SyncRowRequest = SheetsNetwork.SyncRowRequest;
  /** Generated from the `SyncRowResponse` schema, declared once as `SheetsNetwork.SyncRowResponse`. */
  export type SyncRowResponse = SheetsNetwork.SyncRowResponse;
  /** The wire codec for SyncRowResponse, declared once as `SheetsNetwork.SyncRowResponse`. */
  export const SyncRowResponse: typeof SheetsNetwork.SyncRowResponse = SheetsNetwork.SyncRowResponse;
  /** Status of a sync job */
  export type SyncStatus = "pending" | "running" | "complete" | "failed";
  /** Response for sync status queries */
  export interface SyncStatusResponse {
    /** Generated from the `SyncStatusResponse` schema's `error` property. */
    error: Option<string>;
    /** URL where clients can poll the producer directly for faster status updates */
    pollUrl: Option<string>;
    /** Generated from the `SyncStatusResponse` schema's `status` property. */
    status: SyncStatus;
  }
  /** Generated from the `TaskCell` schema, declared once as `SheetsNetwork.TaskCell`. */
  export type TaskCell = SheetsNetwork.TaskCell;
  /** The wire codec for TaskCell, declared once as `SheetsNetwork.TaskCell`. */
  export const TaskCell: typeof SheetsNetwork.TaskCell = SheetsNetwork.TaskCell;
  /** Generated from the `TaskUpdateAttributes` schema, declared once as `SheetsNetwork.TaskUpdateAttributes`. */
  export type TaskUpdateAttributes = SheetsNetwork.TaskUpdateAttributes;
  /** The wire codec for TaskUpdateAttributes, declared once as `SheetsNetwork.TaskUpdateAttributes`. */
  export const TaskUpdateAttributes: typeof SheetsNetwork.TaskUpdateAttributes = SheetsNetwork.TaskUpdateAttributes;
  /** `@tento/lona/sheets`'s `TemplateRowId`: the one declaration, with its `parse` / `of`. */
  export type TemplateRowId = _TemplateRowId;
  /** The `parse` / `of` of `@tento/lona/sheets`'s `TemplateRowId`. */
  export const TemplateRowId: typeof _TemplateRowId = _TemplateRowId;
  /** Generated from the `TemplateRowDef` schema, declared once as `SheetsNetwork.TemplateRowDef`. */
  export type TemplateRowDef = SheetsNetwork.TemplateRowDef;
  /** The wire codec for TemplateRowDef, declared once as `SheetsNetwork.TemplateRowDef`. */
  export const TemplateRowDef: typeof SheetsNetwork.TemplateRowDef = SheetsNetwork.TemplateRowDef;
  /** Generated from the `TimezoneCell` schema, declared once as `SheetsNetwork.TimezoneCell`. */
  export type TimezoneCell = SheetsNetwork.TimezoneCell;
  /** The wire codec for TimezoneCell, declared once as `SheetsNetwork.TimezoneCell`. */
  export const TimezoneCell: typeof SheetsNetwork.TimezoneCell = SheetsNetwork.TimezoneCell;
  /** Inactive │ ├ Active [+ ?trial_start_date] │ │ > ACTIVE PAYMENT PLAN │ │ > User logs in with an authentication method (ie. Google) │ │ > Optionally sets the trial start date if it doesn't yet exist │ │ │ └ PaymentIncomplete │ │ > Saved Payment option fails │ │ │ └ Inactive | > After MAX_RETRIES │ ├ Trial │ │ > User immediately begins trial │ │ │ ├ Active │ │ │ │ │ ... │ │ │ └ TrialExpired │ │ > User has reached the end of their trial │ │ > Try to convert the user to a paying customer │ │ > TODO: do we need a state here? probably nice to keep it explicit │ │ but this is something we can derive │ │ │ └ Inactive | > After 28 days or requested to stop marketing │ └ Invited │ > User had an object shared to them │ ├ [DELETED] │ │ > User *BLOCKS* the invitation │ │ > Separate table indicating blocklists │ └ > User explicitly *DECLINES* the invitation │ ├ Active │ │ │ ... │ └ Trial │ ... User status for display purposes. No longer stored in database - derived from product_keys via active_ustatus(). */
  export type UserStatus = "inactive" | "active" | "paymentIncomplete" | "trial" | "trialExpired" | "invited";
  /** Generated from the `UserDisplay` schema. */
  export interface UserDisplay {
    /** Generated from the `UserDisplay` schema's `activeProduct` property. */
    activeProduct: Option<LonaProduct>;
    /** Generated from the `UserDisplay` schema's `displayName` property. */
    displayName: string;
    /** Generated from the `UserDisplay` schema's `graceExpiresAt` property. */
    graceExpiresAt: Option<DateTime<Utc>>;
    /** Generated from the `UserDisplay` schema's `id` property. */
    id: UserId;
    /** Generated from the `UserDisplay` schema's `isPaymentsTesting` property. */
    isPaymentsTesting: boolean;
    /** Generated from the `UserDisplay` schema's `isServiceAccount` property. */
    isServiceAccount: Option<boolean>;
    /** Generated from the `UserDisplay` schema's `registeredOn` property. */
    registeredOn: Option<DateTime<Utc>>;
    /** Generated from the `UserDisplay` schema's `status` property. */
    status: UserStatus;
    /** Generated from the `UserDisplay` schema's `trialEndsOn` property. */
    trialEndsOn: Option<DateTime<Utc>>;
    /** Generated from the `UserDisplay` schema's `username` property. */
    username: Option<string>;
  }
  /** Generated from the `UserSheetAccessSelect` schema, declared once as `SheetsNetwork.UserSheetAccessSelect`. */
  export type UserSheetAccessSelect = SheetsNetwork.UserSheetAccessSelect;
  /** The wire codec for UserSheetAccessSelect, declared once as `SheetsNetwork.UserSheetAccessSelect`. */
  export const UserSheetAccessSelect: typeof SheetsNetwork.UserSheetAccessSelect = SheetsNetwork.UserSheetAccessSelect;
  /** Generated from the `UserSheetAttributes` schema, declared once as `SheetsNetwork.UserSheetAttributes`. */
  export type UserSheetAttributes = SheetsNetwork.UserSheetAttributes;
  /** The wire codec for UserSheetAttributes, declared once as `SheetsNetwork.UserSheetAttributes`. */
  export const UserSheetAttributes: typeof SheetsNetwork.UserSheetAttributes = SheetsNetwork.UserSheetAttributes;
  /** Generated from the `UserTheme` schema. */
  export type UserTheme = {
    Alias: {
      alias: ScaryUserString;
    };
  } | {
    Custom: Theme;
  };
  /** Generated from the `UserWithAuthDisplay` schema. */
  export interface UserWithAuthDisplay extends UserDisplay {
    /** Generated from the `UserWithAuthDisplay` schema's `auth` property. */
    auth: AuthDisplay[];
  }
  /** Generated from the `WaitlistRequest` schema. */
  export interface WaitlistRequest {
    /** Generated from the `WaitlistRequest` schema's `email` property. */
    email: string;
    /** Generated from the `WaitlistRequest` schema's `source` property. */
    source: Option<string>;
  }
  /** Whether the submit added the address (`true`) or found it already listed. */
  export interface WaitlistResponse {
    /** True when this submit added the address; false when it was already listed. */
    created: boolean;
  }
  /** Generated from the `WeatherCell` schema, declared once as `SheetsNetwork.WeatherCell`. */
  export type WeatherCell = SheetsNetwork.WeatherCell;
  /** The wire codec for WeatherCell, declared once as `SheetsNetwork.WeatherCell`. */
  export const WeatherCell: typeof SheetsNetwork.WeatherCell = SheetsNetwork.WeatherCell;
  /** Generated from the `SemanticTime` schema: `@tento-chrono`'s `SemanticTime`. */
  export type SemanticTime = _SemanticTime;
  /** The wire codec for AuthDisplay: validation, hydration and serialization. */
  export namespace AuthDisplay {
    /** The field table that validates, hydrates and serializes a `AuthDisplay`. */
    export const MODEL: ModelObject<AuthDisplay> = Model.object<AuthDisplay>({
      id: Field.required(Scalar.checked<string, AuthId>("AuthId", Scalar.string, AuthId.parse, null)),
      isPrimary: Field.required(Scalar.boolean),
      requiresRelogin: Field.required(Scalar.boolean),
      scopes: Field.required(Scalar.string),
      source: Field.required(Scalar.string),
    });
    /** The wire JSON `raw` as a `AuthDisplay`; throws when it does not match. */
    export const hydrate: (raw: Json) => AuthDisplay = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `AuthDisplay`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<AuthDisplay> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: AuthDisplay) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for AuthInfoResponse: validation, hydration and serialization. */
  export namespace AuthInfoResponse {
    /** The field table that validates, hydrates and serializes a `AuthInfoResponse`. */
    export const MODEL: ModelObject<AuthInfoResponse> = Model.object<AuthInfoResponse>({
      authId: Field.required(Scalar.checked<string, AuthId>("AuthId", Scalar.string, AuthId.parse, null)),
      expiresAt: WireDecode.nullable(Scalar.checked<string, DateTime<Utc>>("DateTime<Utc>", Scalar.string, Utc.parse, null)),
      issuedAt: Field.required(Scalar.checked<string, DateTime<Utc>>("DateTime<Utc>", Scalar.string, Utc.parse, null)),
      refreshExpiresAt: WireDecode.nullable(Scalar.checked<string, DateTime<Utc>>("DateTime<Utc>", Scalar.string, Utc.parse, null)),
      requiresLogin: WireDecode.nullable(Scalar.boolean),
      scopes: Field.required(Model.array(Scalar.string)),
      source: Field.required(Scalar.string),
    });
    /** The wire JSON `raw` as a `AuthInfoResponse`; throws when it does not match. */
    export const hydrate: (raw: Json) => AuthInfoResponse = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `AuthInfoResponse`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<AuthInfoResponse> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: AuthInfoResponse) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for BillingPortalSession: validation, hydration and serialization. */
  export namespace BillingPortalSession {
    /** The field table that validates, hydrates and serializes a `BillingPortalSession`. */
    export const MODEL: ModelObject<BillingPortalSession> = Model.object<BillingPortalSession>({
      isPaymentsTesting: Field.required(Scalar.boolean),
      url: Field.required(Scalar.string),
    });
    /** The wire JSON `raw` as a `BillingPortalSession`; throws when it does not match. */
    export const hydrate: (raw: Json) => BillingPortalSession = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `BillingPortalSession`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<BillingPortalSession> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: BillingPortalSession) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for CheckoutSession: validation, hydration and serialization. */
  export namespace CheckoutSession {
    /** The field table that validates, hydrates and serializes a `CheckoutSession`. */
    export const MODEL: ModelObject<CheckoutSession> = Model.object<CheckoutSession>({
      url: Field.required(Scalar.string),
    });
    /** The wire JSON `raw` as a `CheckoutSession`; throws when it does not match. */
    export const hydrate: (raw: Json) => CheckoutSession = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `CheckoutSession`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<CheckoutSession> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: CheckoutSession) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for CoreTheme: validation, hydration and serialization. */
  export namespace CoreTheme {
    /** The field table that validates, hydrates and serializes a `CoreTheme`. */
    export const MODEL: ModelObject<CoreTheme> = Model.object<CoreTheme>({
      blue: WireDecode.nullable(Model.union([Scalar.string, Model.array(Scalar.string)])),
      gray: WireDecode.nullable(Model.union([Scalar.string, Model.array(Scalar.string)])),
      green: WireDecode.nullable(Model.union([Scalar.string, Model.array(Scalar.string)])),
      orange: WireDecode.nullable(Model.union([Scalar.string, Model.array(Scalar.string)])),
      purple: WireDecode.nullable(Model.union([Scalar.string, Model.array(Scalar.string)])),
      red: WireDecode.nullable(Model.union([Scalar.string, Model.array(Scalar.string)])),
      teal: WireDecode.nullable(Model.union([Scalar.string, Model.array(Scalar.string)])),
      yellow: WireDecode.nullable(Model.union([Scalar.string, Model.array(Scalar.string)])),
    });
    /** The wire JSON `raw` as a `CoreTheme`; throws when it does not match. */
    export const hydrate: (raw: Json) => CoreTheme = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `CoreTheme`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<CoreTheme> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: CoreTheme) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for CoreThemeVariants: validation, hydration and serialization. */
  export namespace CoreThemeVariants {
    /** The field table that validates, hydrates and serializes a `CoreThemeVariants`. */
    export const MODEL: ModelObject<CoreThemeVariants> = Model.object<CoreThemeVariants>({
      default: WireDecode.nullable(Model.defer(() => CoreTheme.MODEL)),
      dimmed: WireDecode.nullable(Model.defer(() => CoreTheme.MODEL)),
    });
    /** The wire JSON `raw` as a `CoreThemeVariants`; throws when it does not match. */
    export const hydrate: (raw: Json) => CoreThemeVariants = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `CoreThemeVariants`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<CoreThemeVariants> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: CoreThemeVariants) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for EventDb: validation, hydration and serialization. */
  export namespace EventDb {
    /** The field table that validates, hydrates and serializes a `EventDb`. */
    export const MODEL: ModelObject<EventDb> = Model.object<EventDb>({
      attendees: WireDecode.nullable(Scalar.json),
      authId: Field.required(Scalar.checked<string, AuthId>("AuthId", Scalar.string, AuthId.parse, null)),
      calendarId: Field.required(Scalar.checked<string, CalendarId>("CalendarId", Scalar.string, CalendarId.parse, null)),
      category: WireDecode.nullable(Scalar.string),
      conferenceData: WireDecode.nullable(Scalar.json),
      creatorDisplayName: WireDecode.nullable(Scalar.string),
      creatorEmail: WireDecode.nullable(Scalar.string),
      creatorId: WireDecode.nullable(Scalar.string),
      creatorIsSelf: WireDecode.nullable(Scalar.boolean),
      description: WireDecode.nullable(Scalar.string),
      endDate: WireDecode.nullable(Scalar.checked<string, NaiveDate>("NaiveDate", Scalar.string, NaiveDate.parseOpt, null)),
      endTimeZone: WireDecode.nullable(Scalar.string),
      et: WireDecode.nullable(Scalar.checked<string, DateTime<Utc>>("DateTime<Utc>", Scalar.string, Utc.parse, null)),
      etag: Field.required(Scalar.string),
      eventType: WireDecode.nullable(Scalar.string),
      icalId: WireDecode.nullable(Scalar.string),
      id: Field.required(Scalar.checked<string, EventId>("EventId", Scalar.string, EventId.parse, null)),
      location: WireDecode.nullable(Scalar.string),
      queryRangeEnd: WireDecode.nullable(Scalar.checked<string, DateTime<Utc>>("DateTime<Utc>", Scalar.string, Utc.parse, null)),
      queryRangeStart: WireDecode.nullable(Scalar.checked<string, DateTime<Utc>>("DateTime<Utc>", Scalar.string, Utc.parse, null)),
      recurrence: WireDecode.nullable(Model.array(Scalar.string)),
      recurringEventId: WireDecode.nullable(Scalar.checked<string, EventId>("EventId", Scalar.string, EventId.parse, null)),
      source: Field.required(Scalar.string),
      st: WireDecode.nullable(Scalar.checked<string, DateTime<Utc>>("DateTime<Utc>", Scalar.string, Utc.parse, null)),
      startDate: WireDecode.nullable(Scalar.checked<string, NaiveDate>("NaiveDate", Scalar.string, NaiveDate.parseOpt, null)),
      startTimeZone: WireDecode.nullable(Scalar.string),
      status: WireDecode.nullable(Scalar.string),
      suggestedCategory: WireDecode.nullable(Scalar.string),
      suggestedTimezone: WireDecode.nullable(Scalar.string),
      t: WireDecode.nullable(Scalar.string),
      timezone: WireDecode.nullable(Scalar.string),
      transparency: WireDecode.nullable(Scalar.string),
      useSuggestedCategory: WireDecode.nullable(Scalar.boolean),
      visibility: WireDecode.nullable(Scalar.stringUnion(["default", "public", "private", "confidential"] as const)),
    });
    /** The wire JSON `raw` as a `EventDb`; throws when it does not match. */
    export const hydrate: (raw: Json) => EventDb = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `EventDb`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<EventDb> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: EventDb) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for GmailAttachment: validation, hydration and serialization. */
  export namespace GmailAttachment {
    /** The field table that validates, hydrates and serializes a `GmailAttachment`. */
    export const MODEL: ModelObject<GmailAttachment> = Model.object<GmailAttachment>({
      data: Field.required(Scalar.string),
      size: Field.required(Scalar.number),
    });
    /** The wire JSON `raw` as a `GmailAttachment`; throws when it does not match. */
    export const hydrate: (raw: Json) => GmailAttachment = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `GmailAttachment`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<GmailAttachment> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: GmailAttachment) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for GmailAttachmentInfo: validation, hydration and serialization. */
  export namespace GmailAttachmentInfo {
    /** The field table that validates, hydrates and serializes a `GmailAttachmentInfo`. */
    export const MODEL: ModelObject<GmailAttachmentInfo> = Model.object<GmailAttachmentInfo>({
      attachmentId: WireDecode.nullable(Scalar.checked<string, GmailAttachmentId>("GmailAttachmentId", Scalar.string, GmailAttachmentId.parse, null)),
      data: WireDecode.nullable(Scalar.string),
      filename: Field.required(Scalar.string),
      mimeType: Field.required(Scalar.string),
      partId: Field.required(Scalar.string),
      size: Field.required(Scalar.number),
    });
    /** The wire JSON `raw` as a `GmailAttachmentInfo`; throws when it does not match. */
    export const hydrate: (raw: Json) => GmailAttachmentInfo = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `GmailAttachmentInfo`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<GmailAttachmentInfo> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: GmailAttachmentInfo) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for GmailMessageSummary: validation, hydration and serialization. */
  export namespace GmailMessageSummary {
    /** The field table that validates, hydrates and serializes a `GmailMessageSummary`. */
    export const MODEL: ModelObject<GmailMessageSummary> = Model.object<GmailMessageSummary>({
      date: Field.required(Scalar.string),
      from: Field.required(Scalar.string),
      id: Field.required(Scalar.checked<string, GmailMessageId>("GmailMessageId", Scalar.string, GmailMessageId.parse, null)),
      internalDate: WireDecode.nullable(Scalar.string),
      labelIds: Field.required(Model.array(Scalar.string)),
      snippet: Field.required(Scalar.string),
      subject: Field.required(Scalar.string),
      threadId: Field.required(Scalar.checked<string, GmailThreadId>("GmailThreadId", Scalar.string, GmailThreadId.parse, null)),
      to: Field.required(Scalar.string),
    });
    /** The wire JSON `raw` as a `GmailMessageSummary`; throws when it does not match. */
    export const hydrate: (raw: Json) => GmailMessageSummary = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `GmailMessageSummary`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<GmailMessageSummary> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: GmailMessageSummary) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for GmailMessage: validation, hydration and serialization. */
  export namespace GmailMessage {
    /** The field table that validates, hydrates and serializes a `GmailMessage`. */
    export const MODEL: ModelObject<GmailMessage> = Model.object<GmailMessage>({
      attachments: Field.required(Model.array(Model.defer(() => GmailAttachmentInfo.MODEL))),
      html: WireDecode.nullable(Scalar.string),
      summary: Field.required(Model.defer(() => GmailMessageSummary.MODEL)),
      text: WireDecode.nullable(Scalar.string),
      warnings: Field.required(Model.array(Scalar.string)),
    });
    /** The wire JSON `raw` as a `GmailMessage`; throws when it does not match. */
    export const hydrate: (raw: Json) => GmailMessage = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `GmailMessage`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<GmailMessage> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: GmailMessage) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for GmailSearchPage: validation, hydration and serialization. */
  export namespace GmailSearchPage {
    /** The field table that validates, hydrates and serializes a `GmailSearchPage`. */
    export const MODEL: ModelObject<GmailSearchPage> = Model.object<GmailSearchPage>({
      messages: Field.required(Model.array(Model.defer(() => GmailMessageSummary.MODEL))),
      nextPageToken: WireDecode.nullable(Scalar.string),
      resultSizeEstimate: WireDecode.nullable(Scalar.number),
    });
    /** The wire JSON `raw` as a `GmailSearchPage`; throws when it does not match. */
    export const hydrate: (raw: Json) => GmailSearchPage = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `GmailSearchPage`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<GmailSearchPage> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: GmailSearchPage) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for GmailThread: validation, hydration and serialization. */
  export namespace GmailThread {
    /** The field table that validates, hydrates and serializes a `GmailThread`. */
    export const MODEL: ModelObject<GmailThread> = Model.object<GmailThread>({
      id: Field.required(Scalar.checked<string, GmailThreadId>("GmailThreadId", Scalar.string, GmailThreadId.parse, null)),
      messages: Field.required(Model.array(Model.defer(() => GmailMessage.MODEL))),
    });
    /** The wire JSON `raw` as a `GmailThread`; throws when it does not match. */
    export const hydrate: (raw: Json) => GmailThread = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `GmailThread`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<GmailThread> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: GmailThread) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for SemanticThemeVariant: validation, hydration and serialization. */
  export namespace SemanticThemeVariant {
    /** The field table that validates, hydrates and serializes a `SemanticThemeVariant`. */
    export const MODEL: ModelObject<SemanticThemeVariant> = Model.object<SemanticThemeVariant>({
      events: WireDecode.nullable(Scalar.json),
      sheet: WireDecode.nullable(Scalar.json),
    });
    /** The wire JSON `raw` as a `SemanticThemeVariant`; throws when it does not match. */
    export const hydrate: (raw: Json) => SemanticThemeVariant = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `SemanticThemeVariant`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<SemanticThemeVariant> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: SemanticThemeVariant) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for SemanticTheme: validation, hydration and serialization. */
  export namespace SemanticTheme {
    /** The field table that validates, hydrates and serializes a `SemanticTheme`. */
    export const MODEL: ModelObject<SemanticTheme> = Model.object<SemanticTheme>({
      default: WireDecode.nullable(Model.defer(() => SemanticThemeVariant.MODEL)),
      dimmed: WireDecode.nullable(Model.defer(() => SemanticThemeVariant.MODEL)),
    });
    /** The wire JSON `raw` as a `SemanticTheme`; throws when it does not match. */
    export const hydrate: (raw: Json) => SemanticTheme = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `SemanticTheme`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<SemanticTheme> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: SemanticTheme) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for Theme: validation, hydration and serialization. */
  export namespace Theme {
    /** The field table that validates, hydrates and serializes a `Theme`. */
    export const MODEL: ModelObject<Theme> = Model.object<Theme>({
      base: WireDecode.nullable(Model.defer(() => CoreThemeVariants.MODEL)),
      semantic: WireDecode.nullable(Model.defer(() => SemanticTheme.MODEL)),
    });
    /** The wire JSON `raw` as a `Theme`; throws when it does not match. */
    export const hydrate: (raw: Json) => Theme = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `Theme`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<Theme> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: Theme) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for NamedTheme: validation, hydration and serialization. */
  export namespace NamedTheme {
    /** The field table that validates, hydrates and serializes a `NamedTheme`. */
    export const MODEL: ModelObject<NamedTheme> = Model.object<NamedTheme>({
      name: WireDecode.nullable(Scalar.string),
      theme: WireDecode.nullable(Model.defer(() => Theme.MODEL)),
    });
    /** The wire JSON `raw` as a `NamedTheme`; throws when it does not match. */
    export const hydrate: (raw: Json) => NamedTheme = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `NamedTheme`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<NamedTheme> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: NamedTheme) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for UserInfo: validation, hydration and serialization. */
  export namespace UserInfo {
    /** The field table that validates, hydrates and serializes a `UserInfo`. */
    export const MODEL: ModelObject<UserInfo> = Model.object<UserInfo>({
      activeProduct: WireDecode.nullable(Scalar.stringUnion(["Personal", "Pro", "Teams"] as const)),
      displayName: Field.required(Scalar.string),
      graceExpiresAt: WireDecode.nullable(Scalar.checked<string, DateTime<Utc>>("DateTime<Utc>", Scalar.string, Utc.parse, null)),
      id: Field.required(Scalar.checked<string, UserId>("UserId", Scalar.string, UserId.parse, null)),
      isServiceAccount: Field.required(Scalar.boolean),
      theme: Field.required(Model.defer(() => NamedTheme.MODEL)),
    });
    /** The wire JSON `raw` as a `UserInfo`; throws when it does not match. */
    export const hydrate: (raw: Json) => UserInfo = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `UserInfo`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<UserInfo> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: UserInfo) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for InitialPayload: validation, hydration and serialization. */
  export namespace InitialPayload {
    /** The field table that validates, hydrates and serializes a `InitialPayload`. */
    export const MODEL: ModelObject<InitialPayload> = Model.object<InitialPayload>({
      auths: Field.required(Model.array(Model.defer(() => AuthDisplay.MODEL))),
      calendars: Field.required(Model.array(Model.defer(() => CalendarList.MODEL))),
      capabilities: WireDecode.nullable(Model.array(Scalar.string)),
      sheet: WireDecode.nullable(Model.defer(() => UserSheetWithRows.MODEL)),
      sheetList: Field.required(Model.array(Model.defer(() => UserSheet.MODEL))),
      tasks: Field.required(Model.array(Model.defer(() => Task.MODEL))),
      user: Field.required(Model.defer(() => UserInfo.MODEL)),
    });
    /** The wire JSON `raw` as a `InitialPayload`; throws when it does not match. */
    export const hydrate: (raw: Json) => InitialPayload = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `InitialPayload`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<InitialPayload> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: InitialPayload) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for MailAccount: validation, hydration and serialization. */
  export namespace MailAccount {
    /** The field table that validates, hydrates and serializes a `MailAccount`. */
    export const MODEL: ModelObject<MailAccount> = Model.object<MailAccount>({
      authId: Field.required(Scalar.checked<string, AuthId>("AuthId", Scalar.string, AuthId.parse, null)),
      readable: Field.required(Scalar.boolean),
    });
    /** The wire JSON `raw` as a `MailAccount`; throws when it does not match. */
    export const hydrate: (raw: Json) => MailAccount = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `MailAccount`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<MailAccount> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: MailAccount) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for MailConnectBody: validation, hydration and serialization. */
  export namespace MailConnectBody {
    /** The field table that validates, hydrates and serializes a `MailConnectBody`. */
    export const MODEL: ModelObject<MailConnectBody> = Model.object<MailConnectBody>({
      authId: Field.required(Scalar.checked<string, AuthId>("AuthId", Scalar.string, AuthId.parse, null)),
      code: Field.required(Scalar.string),
    });
    /** The wire JSON `raw` as a `MailConnectBody`; throws when it does not match. */
    export const hydrate: (raw: Json) => MailConnectBody = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `MailConnectBody`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<MailConnectBody> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: MailConnectBody) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for ManageRequest: validation, hydration and serialization. */
  export namespace ManageRequest {
    /** The field table that validates, hydrates and serializes a `ManageRequest`. */
    export const MODEL: ModelObject<ManageRequest> = Model.object<ManageRequest>({
      returnUrl: WireDecode.nullable(Scalar.string),
    });
    /** The wire JSON `raw` as a `ManageRequest`; throws when it does not match. */
    export const hydrate: (raw: Json) => ManageRequest = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `ManageRequest`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<ManageRequest> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: ManageRequest) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for ProductKeyItem: validation, hydration and serialization. */
  export namespace ProductKeyItem {
    /** The field table that validates, hydrates and serializes a `ProductKeyItem`. */
    export const MODEL: ModelObject<ProductKeyItem> = Model.object<ProductKeyItem>({
      code: Field.required(Scalar.string),
      createdAt: Field.required(Scalar.checked<string, DateTime<Utc>>("DateTime<Utc>", Scalar.string, Utc.parse, null)),
      eligibility: Field.required(Scalar.string),
      expiresAfterSecs: WireDecode.nullable(Scalar.number),
      expiresAt: WireDecode.nullable(Scalar.checked<string, DateTime<Utc>>("DateTime<Utc>", Scalar.string, Utc.parse, null)),
      isActive: Field.required(Scalar.boolean),
      origin: Field.required(Scalar.string),
      redeemedAt: WireDecode.nullable(Scalar.checked<string, DateTime<Utc>>("DateTime<Utc>", Scalar.string, Utc.parse, null)),
      scope: Field.required(Scalar.string),
      source: Field.required(Scalar.string),
      status: Field.required(Scalar.stringUnion(["Personal", "Pro", "Teams", "Trial", "Invited"] as const)),
    });
    /** The wire JSON `raw` as a `ProductKeyItem`; throws when it does not match. */
    export const hydrate: (raw: Json) => ProductKeyItem = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `ProductKeyItem`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<ProductKeyItem> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: ProductKeyItem) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for PaginatedProductKeysResponse: validation, hydration and serialization. */
  export namespace PaginatedProductKeysResponse {
    /** The field table that validates, hydrates and serializes a `PaginatedProductKeysResponse`. */
    export const MODEL: ModelObject<PaginatedProductKeysResponse> = Model.object<PaginatedProductKeysResponse>({
      items: Field.required(Model.array(Model.defer(() => ProductKeyItem.MODEL))),
      page: Field.required(Scalar.number),
      pageSize: Field.required(Scalar.number),
      total: Field.required(Scalar.number),
    });
    /** The wire JSON `raw` as a `PaginatedProductKeysResponse`; throws when it does not match. */
    export const hydrate: (raw: Json) => PaginatedProductKeysResponse = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `PaginatedProductKeysResponse`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<PaginatedProductKeysResponse> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: PaginatedProductKeysResponse) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for PlanOption: validation, hydration and serialization. */
  export namespace PlanOption {
    /** The field table that validates, hydrates and serializes a `PlanOption`. */
    export const MODEL: ModelObject<PlanOption> = Model.object<PlanOption>({
      action: Field.required(Scalar.stringUnion(["manage", "upgrade", "downgrade", "contact"] as const)),
      id: Field.required(Scalar.checked<string, PlanId>("PlanId", Scalar.string, PlanId.parse, null)),
      priceUsdPerMonth: WireDecode.nullable(Scalar.number),
      priceUsdPerMonthAnnual: WireDecode.nullable(Scalar.number),
      tier: Field.required(Scalar.number),
    });
    /** The wire JSON `raw` as a `PlanOption`; throws when it does not match. */
    export const hydrate: (raw: Json) => PlanOption = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `PlanOption`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<PlanOption> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: PlanOption) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for PlanCatalog: validation, hydration and serialization. */
  export namespace PlanCatalog {
    /** The field table that validates, hydrates and serializes a `PlanCatalog`. */
    export const MODEL: ModelObject<PlanCatalog> = Model.object<PlanCatalog>({
      activeProduct: WireDecode.nullable(Scalar.stringUnion(["Personal", "Pro", "Teams"] as const)),
      activeProductCode: WireDecode.nullable(Scalar.string),
      activeProductExpiresAfterSecs: WireDecode.nullable(Scalar.number),
      activeProductSource: WireDecode.nullable(Scalar.string),
      isPaymentsTesting: Field.required(Scalar.boolean),
      plans: Field.required(Model.array(Model.defer(() => PlanOption.MODEL))),
    });
    /** The wire JSON `raw` as a `PlanCatalog`; throws when it does not match. */
    export const hydrate: (raw: Json) => PlanCatalog = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `PlanCatalog`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<PlanCatalog> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: PlanCatalog) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for ProductKeyRequest: validation, hydration and serialization. */
  export namespace ProductKeyRequest {
    /** The field table that validates, hydrates and serializes a `ProductKeyRequest`. */
    export const MODEL: ModelObject<ProductKeyRequest> = Model.object<ProductKeyRequest>({
      code: Field.required(Scalar.string),
    });
    /** The wire JSON `raw` as a `ProductKeyRequest`; throws when it does not match. */
    export const hydrate: (raw: Json) => ProductKeyRequest = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `ProductKeyRequest`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<ProductKeyRequest> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: ProductKeyRequest) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for ProductKeyResponse: validation, hydration and serialization. */
  export namespace ProductKeyResponse {
    /** The field table that validates, hydrates and serializes a `ProductKeyResponse`. */
    export const MODEL: ModelObject<ProductKeyResponse> = Model.object<ProductKeyResponse>({
      code: WireDecode.nullable(Scalar.string),
      expiresAfterSecs: WireDecode.nullable(Scalar.number),
      fromCookie: Field.required(Scalar.boolean),
      keys: Field.required(Model.array(Model.defer(() => ProductKeyItem.MODEL))),
      status: Field.required(Scalar.string),
      tier: WireDecode.nullable(Scalar.string),
    });
    /** The wire JSON `raw` as a `ProductKeyResponse`; throws when it does not match. */
    export const hydrate: (raw: Json) => ProductKeyResponse = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `ProductKeyResponse`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<ProductKeyResponse> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: ProductKeyResponse) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for PublicSchedulingLinkInfo: validation, hydration and serialization. */
  export namespace PublicSchedulingLinkInfo {
    /** The field table that validates, hydrates and serializes a `PublicSchedulingLinkInfo`. */
    export const MODEL: ModelObject<PublicSchedulingLinkInfo> = Model.object<PublicSchedulingLinkInfo>({
      description: WireDecode.nullable(Scalar.string),
      durationMinutes: Field.required(Scalar.number),
      slug: Field.required(Scalar.string),
      timezone: Field.required(Scalar.string),
      title: Field.required(Scalar.string),
    });
    /** The wire JSON `raw` as a `PublicSchedulingLinkInfo`; throws when it does not match. */
    export const hydrate: (raw: Json) => PublicSchedulingLinkInfo = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `PublicSchedulingLinkInfo`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<PublicSchedulingLinkInfo> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: PublicSchedulingLinkInfo) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for SandboxRequest: validation, hydration and serialization. */
  export namespace SandboxRequest {
    /** The field table that validates, hydrates and serializes a `SandboxRequest`. */
    export const MODEL: ModelObject<SandboxRequest> = Model.object<SandboxRequest>({
      isPaymentsTesting: Field.required(Scalar.boolean),
    });
    /** The wire JSON `raw` as a `SandboxRequest`; throws when it does not match. */
    export const hydrate: (raw: Json) => SandboxRequest = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `SandboxRequest`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<SandboxRequest> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: SandboxRequest) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for SandboxResponse: validation, hydration and serialization. */
  export namespace SandboxResponse {
    /** The field table that validates, hydrates and serializes a `SandboxResponse`. */
    export const MODEL: ModelObject<SandboxResponse> = Model.object<SandboxResponse>({
      isPaymentsTesting: Field.required(Scalar.boolean),
    });
    /** The wire JSON `raw` as a `SandboxResponse`; throws when it does not match. */
    export const hydrate: (raw: Json) => SandboxResponse = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `SandboxResponse`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<SandboxResponse> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: SandboxResponse) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for SigninResult: validation, hydration and serialization. */
  export namespace SigninResult {
    /** The field table that validates, hydrates and serializes a `SigninResult`. */
    export const MODEL: ModelObject<SigninResult> = Model.object<SigninResult>({
      promoStatus: WireDecode.nullable(Scalar.stringUnion(["Personal", "Pro", "Teams", "Trial", "Invited"] as const)),
      scopes: Field.required(Scalar.string),
    });
    /** The wire JSON `raw` as a `SigninResult`; throws when it does not match. */
    export const hydrate: (raw: Json) => SigninResult = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `SigninResult`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<SigninResult> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: SigninResult) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for StartTrialResponse: validation, hydration and serialization. */
  export namespace StartTrialResponse {
    /** The field table that validates, hydrates and serializes a `StartTrialResponse`. */
    export const MODEL: ModelObject<StartTrialResponse> = Model.object<StartTrialResponse>({
      redirect: Field.required(Scalar.string),
    });
    /** The wire JSON `raw` as a `StartTrialResponse`; throws when it does not match. */
    export const hydrate: (raw: Json) => StartTrialResponse = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `StartTrialResponse`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<StartTrialResponse> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: StartTrialResponse) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for SubscriptionSyncResponse: validation, hydration and serialization. */
  export namespace SubscriptionSyncResponse {
    /** The field table that validates, hydrates and serializes a `SubscriptionSyncResponse`. */
    export const MODEL: ModelObject<SubscriptionSyncResponse> = Model.object<SubscriptionSyncResponse>({
      graceExpiresAt: WireDecode.nullable(Scalar.checked<string, DateTime<Utc>>("DateTime<Utc>", Scalar.string, Utc.parse, null)),
      hasActiveKey: Field.required(Scalar.boolean),
    });
    /** The wire JSON `raw` as a `SubscriptionSyncResponse`; throws when it does not match. */
    export const hydrate: (raw: Json) => SubscriptionSyncResponse = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `SubscriptionSyncResponse`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<SubscriptionSyncResponse> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: SubscriptionSyncResponse) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for SyncStatusResponse: validation, hydration and serialization. */
  export namespace SyncStatusResponse {
    /** The field table that validates, hydrates and serializes a `SyncStatusResponse`. */
    export const MODEL: ModelObject<SyncStatusResponse> = Model.object<SyncStatusResponse>({
      error: WireDecode.nullable(Scalar.string),
      pollUrl: WireDecode.nullable(Scalar.string),
      status: Field.required(Scalar.stringUnion(["pending", "running", "complete", "failed"] as const)),
    });
    /** The wire JSON `raw` as a `SyncStatusResponse`; throws when it does not match. */
    export const hydrate: (raw: Json) => SyncStatusResponse = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `SyncStatusResponse`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<SyncStatusResponse> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: SyncStatusResponse) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for UserDisplay: validation, hydration and serialization. */
  export namespace UserDisplay {
    /** The field table that validates, hydrates and serializes a `UserDisplay`. */
    export const MODEL: ModelObject<UserDisplay> = Model.object<UserDisplay>({
      activeProduct: WireDecode.nullable(Scalar.stringUnion(["Personal", "Pro", "Teams"] as const)),
      displayName: Field.required(Scalar.string),
      graceExpiresAt: WireDecode.nullable(Scalar.checked<string, DateTime<Utc>>("DateTime<Utc>", Scalar.string, Utc.parse, null)),
      id: Field.required(Scalar.checked<string, UserId>("UserId", Scalar.string, UserId.parse, null)),
      isPaymentsTesting: Field.required(Scalar.boolean),
      isServiceAccount: WireDecode.nullable(Scalar.boolean),
      registeredOn: WireDecode.nullable(Scalar.checked<string, DateTime<Utc>>("DateTime<Utc>", Scalar.string, Utc.parse, null)),
      status: Field.required(Scalar.stringUnion(["inactive", "active", "paymentIncomplete", "trial", "trialExpired", "invited"] as const)),
      trialEndsOn: WireDecode.nullable(Scalar.checked<string, DateTime<Utc>>("DateTime<Utc>", Scalar.string, Utc.parse, null)),
      username: WireDecode.nullable(Scalar.string),
    });
    /** The wire JSON `raw` as a `UserDisplay`; throws when it does not match. */
    export const hydrate: (raw: Json) => UserDisplay = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `UserDisplay`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<UserDisplay> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: UserDisplay) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for UserWithAuthDisplay: validation, hydration and serialization. */
  export namespace UserWithAuthDisplay {
    /** The field table that validates, hydrates and serializes a `UserWithAuthDisplay`. */
    export const MODEL: ModelObject<UserWithAuthDisplay> = Model.object<UserWithAuthDisplay>({
      ...UserDisplay.MODEL.fields,
      auth: Field.required(Model.array(Model.defer(() => AuthDisplay.MODEL))),
    });
    /** The wire JSON `raw` as a `UserWithAuthDisplay`; throws when it does not match. */
    export const hydrate: (raw: Json) => UserWithAuthDisplay = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `UserWithAuthDisplay`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<UserWithAuthDisplay> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: UserWithAuthDisplay) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for WaitlistRequest: validation, hydration and serialization. */
  export namespace WaitlistRequest {
    /** The field table that validates, hydrates and serializes a `WaitlistRequest`. */
    export const MODEL: ModelObject<WaitlistRequest> = Model.object<WaitlistRequest>({
      email: Field.required(Scalar.string),
      source: WireDecode.nullable(Scalar.string),
    });
    /** The wire JSON `raw` as a `WaitlistRequest`; throws when it does not match. */
    export const hydrate: (raw: Json) => WaitlistRequest = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `WaitlistRequest`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<WaitlistRequest> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: WaitlistRequest) => Json = MODEL.serialize.bind(MODEL);
  }
  /** The wire codec for WaitlistResponse: validation, hydration and serialization. */
  export namespace WaitlistResponse {
    /** The field table that validates, hydrates and serializes a `WaitlistResponse`. */
    export const MODEL: ModelObject<WaitlistResponse> = Model.object<WaitlistResponse>({
      created: Field.required(Scalar.boolean),
    });
    /** The wire JSON `raw` as a `WaitlistResponse`; throws when it does not match. */
    export const hydrate: (raw: Json) => WaitlistResponse = MODEL.hydrate.bind(MODEL);
    /** The wire JSON `raw` as a `WaitlistResponse`, or the mismatch as an error result. */
    export const safeHydrate: (raw: Json) => ModelResult<WaitlistResponse> = MODEL.safeHydrate.bind(MODEL);
    /** `value` as the wire JSON the server reads. */
    export const serialize: (value: WaitlistResponse) => Json = MODEL.serialize.bind(MODEL);
  }
  export namespace AuthDisplay {
    /** The wire JSON `raw` as a new `AuthDisplay`; throws a typed error when it does not match. */
    export function parse(raw: Json): AuthDisplay {
      return WireDecode.parse("AuthDisplay", AuthDisplay.MODEL, raw);
    }
    /** A `AuthDisplay` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: AuthDisplay): AuthDisplay {
      return { ...fields };
    }
  }
  export namespace AuthInfoResponse {
    /** The wire JSON `raw` as a new `AuthInfoResponse`; throws a typed error when it does not match. */
    export function parse(raw: Json): AuthInfoResponse {
      return WireDecode.parse("AuthInfoResponse", AuthInfoResponse.MODEL, raw);
    }
    /** A `AuthInfoResponse` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: AuthInfoResponse): AuthInfoResponse {
      return { ...fields };
    }
  }
  export namespace BillingPortalSession {
    /** The wire JSON `raw` as a new `BillingPortalSession`; throws a typed error when it does not match. */
    export function parse(raw: Json): BillingPortalSession {
      return WireDecode.parse("BillingPortalSession", BillingPortalSession.MODEL, raw);
    }
    /** A `BillingPortalSession` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: BillingPortalSession): BillingPortalSession {
      return { ...fields };
    }
  }
  export namespace CheckoutSession {
    /** The wire JSON `raw` as a new `CheckoutSession`; throws a typed error when it does not match. */
    export function parse(raw: Json): CheckoutSession {
      return WireDecode.parse("CheckoutSession", CheckoutSession.MODEL, raw);
    }
    /** A `CheckoutSession` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: CheckoutSession): CheckoutSession {
      return { ...fields };
    }
  }
  export namespace CoreTheme {
    /** The wire JSON `raw` as a new `CoreTheme`; throws a typed error when it does not match. */
    export function parse(raw: Json): CoreTheme {
      return WireDecode.parse("CoreTheme", CoreTheme.MODEL, raw);
    }
    /** A `CoreTheme` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: CoreTheme): CoreTheme {
      return { ...fields };
    }
  }
  export namespace CoreThemeVariants {
    /** The wire JSON `raw` as a new `CoreThemeVariants`; throws a typed error when it does not match. */
    export function parse(raw: Json): CoreThemeVariants {
      return WireDecode.parse("CoreThemeVariants", CoreThemeVariants.MODEL, raw);
    }
    /** A `CoreThemeVariants` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: CoreThemeVariants): CoreThemeVariants {
      return { ...fields };
    }
  }
  export namespace EventDb {
    /** The wire JSON `raw` as a new `EventDb`; throws a typed error when it does not match. */
    export function parse(raw: Json): EventDb {
      return WireDecode.parse("EventDb", EventDb.MODEL, raw);
    }
    /** A `EventDb` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: EventDb): EventDb {
      return { ...fields };
    }
  }
  export namespace GmailAttachment {
    /** The wire JSON `raw` as a new `GmailAttachment`; throws a typed error when it does not match. */
    export function parse(raw: Json): GmailAttachment {
      return WireDecode.parse("GmailAttachment", GmailAttachment.MODEL, raw);
    }
    /** A `GmailAttachment` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: GmailAttachment): GmailAttachment {
      return { ...fields };
    }
  }
  export namespace GmailAttachmentInfo {
    /** The wire JSON `raw` as a new `GmailAttachmentInfo`; throws a typed error when it does not match. */
    export function parse(raw: Json): GmailAttachmentInfo {
      return WireDecode.parse("GmailAttachmentInfo", GmailAttachmentInfo.MODEL, raw);
    }
    /** A `GmailAttachmentInfo` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: GmailAttachmentInfo): GmailAttachmentInfo {
      return { ...fields };
    }
  }
  export namespace GmailMessageSummary {
    /** The wire JSON `raw` as a new `GmailMessageSummary`; throws a typed error when it does not match. */
    export function parse(raw: Json): GmailMessageSummary {
      return WireDecode.parse("GmailMessageSummary", GmailMessageSummary.MODEL, raw);
    }
    /** A `GmailMessageSummary` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: GmailMessageSummary): GmailMessageSummary {
      return { ...fields };
    }
  }
  export namespace GmailMessage {
    /** The wire JSON `raw` as a new `GmailMessage`; throws a typed error when it does not match. */
    export function parse(raw: Json): GmailMessage {
      return WireDecode.parse("GmailMessage", GmailMessage.MODEL, raw);
    }
    /** A `GmailMessage` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: GmailMessage): GmailMessage {
      return { ...fields };
    }
  }
  export namespace GmailSearchPage {
    /** The wire JSON `raw` as a new `GmailSearchPage`; throws a typed error when it does not match. */
    export function parse(raw: Json): GmailSearchPage {
      return WireDecode.parse("GmailSearchPage", GmailSearchPage.MODEL, raw);
    }
    /** A `GmailSearchPage` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: GmailSearchPage): GmailSearchPage {
      return { ...fields };
    }
  }
  export namespace GmailThread {
    /** The wire JSON `raw` as a new `GmailThread`; throws a typed error when it does not match. */
    export function parse(raw: Json): GmailThread {
      return WireDecode.parse("GmailThread", GmailThread.MODEL, raw);
    }
    /** A `GmailThread` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: GmailThread): GmailThread {
      return { ...fields };
    }
  }
  export namespace SemanticThemeVariant {
    /** The wire JSON `raw` as a new `SemanticThemeVariant`; throws a typed error when it does not match. */
    export function parse(raw: Json): SemanticThemeVariant {
      return WireDecode.parse("SemanticThemeVariant", SemanticThemeVariant.MODEL, raw);
    }
    /** A `SemanticThemeVariant` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: SemanticThemeVariant): SemanticThemeVariant {
      return { ...fields };
    }
  }
  export namespace SemanticTheme {
    /** The wire JSON `raw` as a new `SemanticTheme`; throws a typed error when it does not match. */
    export function parse(raw: Json): SemanticTheme {
      return WireDecode.parse("SemanticTheme", SemanticTheme.MODEL, raw);
    }
    /** A `SemanticTheme` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: SemanticTheme): SemanticTheme {
      return { ...fields };
    }
  }
  export namespace Theme {
    /** The wire JSON `raw` as a new `Theme`; throws a typed error when it does not match. */
    export function parse(raw: Json): Theme {
      return WireDecode.parse("Theme", Theme.MODEL, raw);
    }
    /** A `Theme` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: Theme): Theme {
      return { ...fields };
    }
  }
  export namespace NamedTheme {
    /** The wire JSON `raw` as a new `NamedTheme`; throws a typed error when it does not match. */
    export function parse(raw: Json): NamedTheme {
      return WireDecode.parse("NamedTheme", NamedTheme.MODEL, raw);
    }
    /** A `NamedTheme` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: NamedTheme): NamedTheme {
      return { ...fields };
    }
  }
  export namespace UserInfo {
    /** The wire JSON `raw` as a new `UserInfo`; throws a typed error when it does not match. */
    export function parse(raw: Json): UserInfo {
      return WireDecode.parse("UserInfo", UserInfo.MODEL, raw);
    }
    /** A `UserInfo` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: UserInfo): UserInfo {
      return { ...fields };
    }
  }
  export namespace InitialPayload {
    /** The wire JSON `raw` as a new `InitialPayload`; throws a typed error when it does not match. */
    export function parse(raw: Json): InitialPayload {
      return WireDecode.parse("InitialPayload", InitialPayload.MODEL, raw);
    }
    /** A `InitialPayload` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: InitialPayload): InitialPayload {
      return { ...fields };
    }
  }
  export namespace MailAccount {
    /** The wire JSON `raw` as a new `MailAccount`; throws a typed error when it does not match. */
    export function parse(raw: Json): MailAccount {
      return WireDecode.parse("MailAccount", MailAccount.MODEL, raw);
    }
    /** A `MailAccount` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: MailAccount): MailAccount {
      return { ...fields };
    }
  }
  export namespace MailConnectBody {
    /** The wire JSON `raw` as a new `MailConnectBody`; throws a typed error when it does not match. */
    export function parse(raw: Json): MailConnectBody {
      return WireDecode.parse("MailConnectBody", MailConnectBody.MODEL, raw);
    }
    /** A `MailConnectBody` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: MailConnectBody): MailConnectBody {
      return { ...fields };
    }
  }
  export namespace ManageRequest {
    /** The wire JSON `raw` as a new `ManageRequest`; throws a typed error when it does not match. */
    export function parse(raw: Json): ManageRequest {
      return WireDecode.parse("ManageRequest", ManageRequest.MODEL, raw);
    }
    /** A `ManageRequest` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: ManageRequest): ManageRequest {
      return { ...fields };
    }
  }
  export namespace ProductKeyItem {
    /** The wire JSON `raw` as a new `ProductKeyItem`; throws a typed error when it does not match. */
    export function parse(raw: Json): ProductKeyItem {
      return WireDecode.parse("ProductKeyItem", ProductKeyItem.MODEL, raw);
    }
    /** A `ProductKeyItem` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: ProductKeyItem): ProductKeyItem {
      return { ...fields };
    }
  }
  export namespace PaginatedProductKeysResponse {
    /** The wire JSON `raw` as a new `PaginatedProductKeysResponse`; throws a typed error when it does not match. */
    export function parse(raw: Json): PaginatedProductKeysResponse {
      return WireDecode.parse("PaginatedProductKeysResponse", PaginatedProductKeysResponse.MODEL, raw);
    }
    /** A `PaginatedProductKeysResponse` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: PaginatedProductKeysResponse): PaginatedProductKeysResponse {
      return { ...fields };
    }
  }
  export namespace PlanOption {
    /** The wire JSON `raw` as a new `PlanOption`; throws a typed error when it does not match. */
    export function parse(raw: Json): PlanOption {
      return WireDecode.parse("PlanOption", PlanOption.MODEL, raw);
    }
    /** A `PlanOption` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: PlanOption): PlanOption {
      return { ...fields };
    }
  }
  export namespace PlanCatalog {
    /** The wire JSON `raw` as a new `PlanCatalog`; throws a typed error when it does not match. */
    export function parse(raw: Json): PlanCatalog {
      return WireDecode.parse("PlanCatalog", PlanCatalog.MODEL, raw);
    }
    /** A `PlanCatalog` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: PlanCatalog): PlanCatalog {
      return { ...fields };
    }
  }
  export namespace ProductKeyRequest {
    /** The wire JSON `raw` as a new `ProductKeyRequest`; throws a typed error when it does not match. */
    export function parse(raw: Json): ProductKeyRequest {
      return WireDecode.parse("ProductKeyRequest", ProductKeyRequest.MODEL, raw);
    }
    /** A `ProductKeyRequest` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: ProductKeyRequest): ProductKeyRequest {
      return { ...fields };
    }
  }
  export namespace ProductKeyResponse {
    /** The wire JSON `raw` as a new `ProductKeyResponse`; throws a typed error when it does not match. */
    export function parse(raw: Json): ProductKeyResponse {
      return WireDecode.parse("ProductKeyResponse", ProductKeyResponse.MODEL, raw);
    }
    /** A `ProductKeyResponse` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: ProductKeyResponse): ProductKeyResponse {
      return { ...fields };
    }
  }
  export namespace PublicSchedulingLinkInfo {
    /** The wire JSON `raw` as a new `PublicSchedulingLinkInfo`; throws a typed error when it does not match. */
    export function parse(raw: Json): PublicSchedulingLinkInfo {
      return WireDecode.parse("PublicSchedulingLinkInfo", PublicSchedulingLinkInfo.MODEL, raw);
    }
    /** A `PublicSchedulingLinkInfo` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: PublicSchedulingLinkInfo): PublicSchedulingLinkInfo {
      return { ...fields };
    }
  }
  export namespace SandboxRequest {
    /** The wire JSON `raw` as a new `SandboxRequest`; throws a typed error when it does not match. */
    export function parse(raw: Json): SandboxRequest {
      return WireDecode.parse("SandboxRequest", SandboxRequest.MODEL, raw);
    }
    /** A `SandboxRequest` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: SandboxRequest): SandboxRequest {
      return { ...fields };
    }
  }
  export namespace SandboxResponse {
    /** The wire JSON `raw` as a new `SandboxResponse`; throws a typed error when it does not match. */
    export function parse(raw: Json): SandboxResponse {
      return WireDecode.parse("SandboxResponse", SandboxResponse.MODEL, raw);
    }
    /** A `SandboxResponse` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: SandboxResponse): SandboxResponse {
      return { ...fields };
    }
  }
  export namespace SigninResult {
    /** The wire JSON `raw` as a new `SigninResult`; throws a typed error when it does not match. */
    export function parse(raw: Json): SigninResult {
      return WireDecode.parse("SigninResult", SigninResult.MODEL, raw);
    }
    /** A `SigninResult` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: SigninResult): SigninResult {
      return { ...fields };
    }
  }
  export namespace StartTrialResponse {
    /** The wire JSON `raw` as a new `StartTrialResponse`; throws a typed error when it does not match. */
    export function parse(raw: Json): StartTrialResponse {
      return WireDecode.parse("StartTrialResponse", StartTrialResponse.MODEL, raw);
    }
    /** A `StartTrialResponse` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: StartTrialResponse): StartTrialResponse {
      return { ...fields };
    }
  }
  export namespace SubscriptionSyncResponse {
    /** The wire JSON `raw` as a new `SubscriptionSyncResponse`; throws a typed error when it does not match. */
    export function parse(raw: Json): SubscriptionSyncResponse {
      return WireDecode.parse("SubscriptionSyncResponse", SubscriptionSyncResponse.MODEL, raw);
    }
    /** A `SubscriptionSyncResponse` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: SubscriptionSyncResponse): SubscriptionSyncResponse {
      return { ...fields };
    }
  }
  export namespace SyncStatusResponse {
    /** The wire JSON `raw` as a new `SyncStatusResponse`; throws a typed error when it does not match. */
    export function parse(raw: Json): SyncStatusResponse {
      return WireDecode.parse("SyncStatusResponse", SyncStatusResponse.MODEL, raw);
    }
    /** A `SyncStatusResponse` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: SyncStatusResponse): SyncStatusResponse {
      return { ...fields };
    }
  }
  export namespace UserDisplay {
    /** The wire JSON `raw` as a new `UserDisplay`; throws a typed error when it does not match. */
    export function parse(raw: Json): UserDisplay {
      return WireDecode.parse("UserDisplay", UserDisplay.MODEL, raw);
    }
    /** A `UserDisplay` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: UserDisplay): UserDisplay {
      return { ...fields };
    }
  }
  export namespace UserWithAuthDisplay {
    /** The wire JSON `raw` as a new `UserWithAuthDisplay`; throws a typed error when it does not match. */
    export function parse(raw: Json): UserWithAuthDisplay {
      return WireDecode.parse("UserWithAuthDisplay", UserWithAuthDisplay.MODEL, raw);
    }
    /** A `UserWithAuthDisplay` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: UserWithAuthDisplay): UserWithAuthDisplay {
      return { ...fields };
    }
  }
  export namespace WaitlistRequest {
    /** The wire JSON `raw` as a new `WaitlistRequest`; throws a typed error when it does not match. */
    export function parse(raw: Json): WaitlistRequest {
      return WireDecode.parse("WaitlistRequest", WaitlistRequest.MODEL, raw);
    }
    /** A `WaitlistRequest` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: WaitlistRequest): WaitlistRequest {
      return { ...fields };
    }
  }
  export namespace WaitlistResponse {
    /** The wire JSON `raw` as a new `WaitlistResponse`; throws a typed error when it does not match. */
    export function parse(raw: Json): WaitlistResponse {
      return WireDecode.parse("WaitlistResponse", WaitlistResponse.MODEL, raw);
    }
    /** A `WaitlistResponse` from every one of its fields (a nullable one stated as `null`). */
    export function make(fields: WaitlistResponse): WaitlistResponse {
      return { ...fields };
    }
  }
  /** Generated from the OpenAPI document's paths: each route's methods, with the request and response types they take and return. */
  export type Routes = {
    "/api/calendars": {
      get: {
        response: CalendarList[]
      }
      post: {
        config: {
          body: AddCalendarRequest
        }
      }
    }
    "/api/debug/cells": {
      get: {
        config: {
          query: {
            row: string,
            start: NaiveDate,
            end: NaiveDate,
          }
        }
        response: SheetRowDataResponse
      }
    }
    "/api/mail/accounts": {
      get: {
        response: MailAccount[]
      }
    }
    "/api/mail/connect": {
      post: {
        config: {
          body: MailConnectBody
        }
        response: MailAccount
      }
    }
    "/api/mail/messages/{messageId}": {
      get: {
        config: {
          query: {
            authId: AuthId,
          }
          path: {
            messageId: GmailMessageId
          }
        }
        response: GmailMessage
      }
    }
    "/api/mail/messages/{messageId}/attachments/{attachmentId}": {
      get: {
        config: {
          query: {
            authId: AuthId,
          }
          path: {
            messageId: GmailMessageId
            attachmentId: GmailAttachmentId
          }
        }
        response: GmailAttachment
      }
    }
    "/api/mail/search": {
      get: {
        config: {
          query: {
            authId: AuthId,
            query: string,
            limit: Option<number>,
            pageToken: Option<string>,
          }
        }
        response: GmailSearchPage
      }
    }
    "/api/mail/threads/{threadId}": {
      get: {
        config: {
          query: {
            authId: AuthId,
          }
          path: {
            threadId: GmailThreadId
          }
        }
        response: GmailThread
      }
    }
    "/api/public/scheduling-links/{slug}": {
      get: {
        config: {
          query: {
            username: Option<string>,
          }
          path: {
            slug: string
          }
        }
        response: PublicSchedulingLinkInfo
      }
    }
    "/api/rows": {
      post: {
        config: {
          body: NewRow
        }
        response: CreatedRow
      }
    }
    "/api/rows/all": {
      get: {
        config: {
          query: {
            deleted: Option<boolean>,
            page: Option<number>,
            pageSize: Option<number>,
            sortBy: Option<string>,
            sortDirection: Option<string>,
            rowType: Option<string>,
          }
        }
        response: PaginatedRowsResponse
      }
    }
    "/api/rows/linkable": {
      get: {
        response: LinkableRow[]
      }
      post: {
        config: {
          body: LinkRowRequest
        }
      }
    }
    "/api/rows/{rowKey}": {
      get: {
        config: {
          path: {
            rowKey: RowNetworkKey
          }
        }
        response: Option<SheetRowDb>
      }
      delete: {
        config: {
          path: {
            rowKey: RowNetworkKey
          }
        }
      }
      patch: {
        config: {
          path: {
            rowKey: RowNetworkKey
          }
          body: PatchRow_PendingValidation
        }
        response: PatchRowResponse
      }
    }
    "/api/rows/{rowKey}/cells": {
      get: {
        config: {
          query: {
            start: NaiveDate,
            end: NaiveDate,
            mock_sync_delay: Option<number>,
            booking_id: Option<Uuid>,
          }
          path: {
            rowKey: RowNetworkKey
          }
        }
        response: SheetCell[]
      }
      post: {
        config: {
          path: {
            rowKey: RowNetworkKey
          }
          body: CellWriteRequest
        }
        response: CellWriteResponse
      }
    }
    "/api/rows/{rowKey}/cells/generate": {
      post: {
        config: {
          path: {
            rowKey: RowNetworkKey
          }
          body: Body
        }
        response: SheetCell
      }
    }
    "/api/rows/{rowKey}/exists": {
      get: {
        config: {
          query: {
            excludeRowId: Option<RowNetworkKey>,
          }
          path: {
            rowKey: RowNetworkKey
          }
        }
        response: LookupKeyExistsResponse
      }
    }
    "/api/rows/{rowKey}/restore": {
      post: {
        config: {
          path: {
            rowKey: RowNetworkKey
          }
          body: RestoreRequest
        }
      }
    }
    "/api/rows/{rowKey}/sync": {
      post: {
        config: {
          path: {
            rowKey: RowNetworkKey
          }
          body: SyncRowRequest
        }
        response: SyncRowResponse
      }
    }
    "/api/sheets": {
      get: {
        response: Option<UserSheetWithRows>
      }
      post: {
        config: {
          body: NewUserSheet
        }
        response: UserSheetWithRows
      }
    }
    "/api/sheets/list": {
      get: {
        config: {
          query: {
            deleted: Option<boolean>,
          }
        }
      }
    }
    "/api/sheets/{sheetKey}": {
      get: {
        config: {
          path: {
            sheetKey: SheetNetworkKey
          }
        }
        response: Option<UserSheetWithRows>
      }
      delete: {
        config: {
          path: {
            sheetKey: SheetNetworkKey
          }
        }
      }
      patch: {
        config: {
          path: {
            sheetKey: SheetNetworkKey
          }
          body: UserSheetAttributes
        }
      }
    }
    "/api/sheets/{sheetKey}/acl": {
      get: {
        config: {
          path: {
            sheetKey: SheetNetworkKey
          }
        }
        response: UserSheetAccessSelect[]
      }
      post: {
        config: {
          path: {
            sheetKey: SheetNetworkKey
          }
          body: CreateAcl
        }
      }
      delete: {
        config: {
          path: {
            sheetKey: SheetNetworkKey
          }
          body: DeleteAcl
        }
      }
    }
    "/api/sheets/{sheetKey}/cells": {
      get: {
        config: {
          query: {
            start: NaiveDate,
            end: NaiveDate,
            mock_sync_delay: Option<number>,
            booking_id: Option<Uuid>,
          }
          path: {
            sheetKey: SheetNetworkKey
          }
        }
        response: Option<SheetRowDataResponse[]>
      }
    }
    "/api/sheets/{sheetKey}/cells/batch": {
      post: {
        config: {
          path: {
            sheetKey: SheetNetworkKey
          }
          body: BatchCellsRequest
        }
        response: Option<BatchCellsResponse>
      }
    }
    "/api/sheets/{sheetKey}/reorder": {
      post: {
        config: {
          path: {
            sheetKey: SheetNetworkKey
          }
          body: SheetReorderBodySchema
        }
        response: SheetReorderResponse
      }
    }
    "/api/sheets/{sheetKey}/resolve": {
      get: {
        config: {
          path: {
            sheetKey: SheetNetworkKey
          }
        }
        response: Option<ResolvedSheetKey>
      }
    }
    "/api/sheets/{sheetKey}/resolve/rows": {
      get: {
        config: {
          path: {
            sheetKey: SheetNetworkKey
          }
        }
        response: Option<ResolvedRowsResponse>
      }
    }
    "/api/sheets/{sheetKey}/restore": {
      post: {
        config: {
          path: {
            sheetKey: SheetNetworkKey
          }
        }
      }
    }
    "/api/sheets/{sheetKey}/row": {
      get: {
        config: {
          path: {
            sheetKey: SheetNetworkKey
          }
        }
        response: Option<SheetRow[]>
      }
      post: {
        config: {
          path: {
            sheetKey: SheetNetworkKey
          }
          body: NewRowBody
        }
        response: CreateRowResponse
      }
    }
    "/api/sheets/{sheetKey}/row/{rowKey}": {
      delete: {
        config: {
          path: {
            sheetKey: SheetNetworkKey
            rowKey: RowNetworkKey
          }
        }
      }
    }
    "/api/sheets/{sheetKey}/row/{rowKey}/hydrate-children": {
      post: {
        config: {
          path: {
            sheetKey: SheetNetworkKey
            rowKey: RowNetworkKey
          }
          body: HydrateChildrenBody
        }
        response: HydrateChildrenResponse
      }
    }
    "/api/sheets/{sheetKey}/row/{rowKey}/reorder": {
      post: {
        config: {
          path: {
            sheetKey: SheetNetworkKey
            rowKey: RowNetworkKey
          }
          body: RowReorderBodySchema
        }
        response: RowReorderResponse
      }
    }
    "/api/sheets/{sheetKey}/row/{rowKey}/sync-reset": {
      post: {
        config: {
          path: {
            sheetKey: SheetNetworkKey
            rowKey: RowNetworkKey
          }
        }
      }
    }
    "/api/sync/{syncKey}/status": {
      get: {
        config: {
          path: {
            syncKey: SyncKey
          }
        }
        response: Option<SyncStatusResponse>
      }
    }
    "/api/tasks": {
      get: {
        response: Task[]
      }
      post: {
        config: {
          body: TaskAttributes
        }
        response: Task
      }
    }
    "/api/tasks/list/test": {
      get: {
        response: Task[]
      }
    }
    "/api/tasks/{taskId}": {
      get: {
        config: {
          path: {
            taskId: TaskId
          }
        }
        response: Task
      }
      delete: {
        config: {
          path: {
            taskId: TaskId
          }
        }
      }
      patch: {
        config: {
          path: {
            taskId: TaskId
          }
          body: TaskUpdateAttributes
        }
      }
    }
    "/api/user": {
      get: {
        response: UserWithAuthDisplay
      }
      delete: {
      }
    }
    "/api/user/auths": {
      get: {
        response: AuthInfoResponse[]
      }
    }
    "/api/user/catalog": {
      get: {
        response: PlanCatalog
      }
    }
    "/api/user/connections/{source}": {
      post: {
        config: {
          path: {
            source: string
          }
          body: ConnectionsBody
        }
      }
    }
    "/api/user/connections/{source}/aid/{authId}": {
      delete: {
        config: {
          path: {
            source: string
            authId: AuthId
          }
        }
      }
    }
    "/api/user/connections/{source}/redirect": {
      get: {
        config: {
          path: {
            source: string
          }
        }
      }
    }
    "/api/user/id": {
      get: {
      }
    }
    "/api/user/initial_payload": {
      get: {
        config: {
          query: {
            skey: Option<string>,
          }
        }
        response: InitialPayload
      }
    }
    "/api/user/payments/customer-id": {
      get: {
        config: {
          query: {
            mode: Option<PaymentsModeParam>,
          }
        }
      }
    }
    "/api/user/payments/sandbox": {
      post: {
        config: {
          body: SandboxRequest
        }
        response: SandboxResponse
      }
    }
    "/api/user/signin": {
      post: {
        config: {
          query: {
            code: string,
            promo: Option<string>,
          }
        }
        response: SigninResult
      }
    }
    "/api/user/signin/outlook/redirect": {
      get: {
        config: {
          query: {
            code: Option<string>,
            state: Option<string>,
            error: Option<string>,
            error_description: Option<string>,
          }
        }
      }
    }
    "/api/user/subscription/checkout": {
      post: {
        config: {
          query: {
            product: string,
            isYearly: Option<boolean>,
            returnUrl: Option<string>,
            cancelUrl: Option<string>,
          }
        }
        response: CheckoutSession
      }
    }
    "/api/user/subscription/manage": {
      post: {
        config: {
          body: ManageRequest
        }
        response: BillingPortalSession
      }
    }
    "/api/user/subscription/product-keys": {
      get: {
        config: {
          query: {
            active: Option<boolean>,
            expired: Option<boolean>,
            page: Option<number>,
            pageSize: Option<number>,
            createdAfter: Option<DateTime<Utc>>,
            createdBefore: Option<DateTime<Utc>>,
            expiresAfter: Option<DateTime<Utc>>,
            expiresBefore: Option<DateTime<Utc>>,
          }
        }
        response: PaginatedProductKeysResponse
      }
    }
    "/api/user/subscription/promo-status": {
      get: {
        response: ProductKeyResponse
      }
    }
    "/api/user/subscription/promo-status/ack": {
      post: {
      }
    }
    "/api/user/subscription/redeem-key": {
      post: {
        config: {
          body: ProductKeyRequest
        }
        response: ProductKeyResponse
      }
    }
    "/api/user/subscription/start-trial": {
      post: {
        config: {
          query: {
            timezone: Option<string>,
          }
        }
        response: StartTrialResponse
      }
    }
    "/api/user/subscription/success": {
      get: {
        config: {
          query: {
            next: Option<string>,
          }
        }
      }
    }
    "/api/user/subscription/sync": {
      get: {
        config: {
          query: {
            force: boolean,
          }
        }
        response: SubscriptionSyncResponse
      }
    }
    "/api/user/themes": {
      patch: {
        config: {
          body: Option<UserTheme>
        }
      }
    }
    "/api/user/tz/transitions": {
      get: {
        response: EventDb[]
      }
    }
    "/api/user/waitlist": {
      post: {
        config: {
          body: WaitlistRequest
        }
        response: WaitlistResponse
      }
    }
  };
  /** Generated from the OpenAPI document's paths: each route's methods, with the `parse` its response is read through. */
  export const REVIVERS = {
    "/api/calendars": {
      parse: {
        get: (p: Json[]) => p.map(CalendarList.parse),
      },
    },
    "/api/debug/cells": {
      parse: {
        get: SheetRowDataResponse.parse,
      },
    },
    "/api/mail/accounts": {
      parse: {
        get: (p: Json[]) => p.map(MailAccount.parse),
      },
    },
    "/api/mail/connect": {
      parse: {
        post: MailAccount.parse,
      },
    },
    "/api/mail/messages/{messageId}": {
      parse: {
        get: GmailMessage.parse,
      },
    },
    "/api/mail/messages/{messageId}/attachments/{attachmentId}": {
      parse: {
        get: GmailAttachment.parse,
      },
    },
    "/api/mail/search": {
      parse: {
        get: GmailSearchPage.parse,
      },
    },
    "/api/mail/threads/{threadId}": {
      parse: {
        get: GmailThread.parse,
      },
    },
    "/api/public/scheduling-links/{slug}": {
      parse: {
        get: PublicSchedulingLinkInfo.parse,
      },
    },
    "/api/rows": {
      parse: {
        post: CreatedRow.parse,
      },
    },
    "/api/rows/all": {
      parse: {
        get: PaginatedRowsResponse.parse,
      },
    },
    "/api/rows/linkable": {
      parse: {
        get: (p: Json[]) => p.map(LinkableRow.parse),
      },
    },
    "/api/rows/{rowKey}": {
      parse: {
        get: SheetRowDb.parse,
        patch: PatchRowResponse.parse,
      },
    },
    "/api/rows/{rowKey}/cells": {
      parse: {
        get: (p: Json[]) => p.map(SheetCellSchema.parse),
        post: CellWriteResponse.parse,
      },
    },
    "/api/rows/{rowKey}/cells/generate": {
      parse: {
        post: SheetCellSchema.parse,
      },
    },
    "/api/rows/{rowKey}/exists": {
      parse: {
        get: LookupKeyExistsResponse.parse,
      },
    },
    "/api/rows/{rowKey}/sync": {
      parse: {
        post: SyncRowResponse.parse,
      },
    },
    "/api/sheets": {
      parse: {
        get: UserSheetWithRows.parse,
        post: UserSheetWithRows.parse,
      },
    },
    "/api/sheets/{sheetKey}": {
      parse: {
        get: UserSheetWithRows.parse,
      },
    },
    "/api/sheets/{sheetKey}/acl": {
      parse: {
        get: (p: Json[]) => p.map(UserSheetAccessSelect.parse),
      },
    },
    "/api/sheets/{sheetKey}/cells": {
      parse: {
        get: (p: Json[]) => p.map(SheetRowDataResponse.parse),
      },
    },
    "/api/sheets/{sheetKey}/cells/batch": {
      parse: {
        post: BatchCellsResponse.parse,
      },
    },
    "/api/sheets/{sheetKey}/reorder": {
      parse: {
        post: SheetReorderResponse.parse,
      },
    },
    "/api/sheets/{sheetKey}/resolve": {
      parse: {
        get: ResolvedSheetKey.parse,
      },
    },
    "/api/sheets/{sheetKey}/resolve/rows": {
      parse: {
        get: ResolvedRowsResponse.parse,
      },
    },
    "/api/sheets/{sheetKey}/row": {
      parse: {
        get: (p: Json[]) => p.map(SheetRow.parse),
        post: CreateRowResponse.parse,
      },
    },
    "/api/sheets/{sheetKey}/row/{rowKey}/hydrate-children": {
      parse: {
        post: HydrateChildrenResponse.parse,
      },
    },
    "/api/sheets/{sheetKey}/row/{rowKey}/reorder": {
      parse: {
        post: RowReorderResponse.parse,
      },
    },
    "/api/sync/{syncKey}/status": {
      parse: {
        get: SyncStatusResponse.parse,
      },
    },
    "/api/tasks": {
      parse: {
        get: (p: Json[]) => p.map(Task.parse),
        post: Task.parse,
      },
    },
    "/api/tasks/list/test": {
      parse: {
        get: (p: Json[]) => p.map(Task.parse),
      },
    },
    "/api/tasks/{taskId}": {
      parse: {
        get: Task.parse,
      },
    },
    "/api/user": {
      parse: {
        get: UserWithAuthDisplay.parse,
      },
    },
    "/api/user/auths": {
      parse: {
        get: (p: Json[]) => p.map(AuthInfoResponse.parse),
      },
    },
    "/api/user/catalog": {
      parse: {
        get: PlanCatalog.parse,
      },
    },
    "/api/user/initial_payload": {
      parse: {
        get: InitialPayload.parse,
      },
    },
    "/api/user/payments/sandbox": {
      parse: {
        post: SandboxResponse.parse,
      },
    },
    "/api/user/signin": {
      parse: {
        post: SigninResult.parse,
      },
    },
    "/api/user/subscription/checkout": {
      parse: {
        post: CheckoutSession.parse,
      },
    },
    "/api/user/subscription/manage": {
      parse: {
        post: BillingPortalSession.parse,
      },
    },
    "/api/user/subscription/product-keys": {
      parse: {
        get: PaginatedProductKeysResponse.parse,
      },
    },
    "/api/user/subscription/promo-status": {
      parse: {
        get: ProductKeyResponse.parse,
      },
    },
    "/api/user/subscription/redeem-key": {
      parse: {
        post: ProductKeyResponse.parse,
      },
    },
    "/api/user/subscription/start-trial": {
      parse: {
        post: StartTrialResponse.parse,
      },
    },
    "/api/user/subscription/sync": {
      parse: {
        get: SubscriptionSyncResponse.parse,
      },
    },
    "/api/user/tz/transitions": {
      parse: {
        get: (p: Json[]) => p.map(EventDb.parse),
      },
    },
    "/api/user/waitlist": {
      parse: {
        post: WaitlistResponse.parse,
      },
    },
  };
}
